/* eslint-disable */
// @ts-nocheck
export * from "./schema-types";
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import type * as Types from "./schema-types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type FlowsFragmentFragment = {
  __typename: "Flow";
  id: string;
  created: string;
  failed: boolean;
  phase: string;
  status: string;
  changelist: { __typename: "Changelist"; id: string; description: string };
  launched_by: { __typename: "User"; name: string; email: string };
  report_datetime: { __typename: "DateTimeHuman"; short: string; long: string; long_utc: string; iso: string } | null;
  inputs: Array<{
    __typename: "FlowInput";
    name: string;
    source_table: {
      __typename: "SourceTable";
      id: string;
      name: string;
      project: string;
      bundle: {
        __typename: "SourceBundle";
        report_handle: any;
        recent_failed_probe: string | null;
        recent_successful_probe: string | null;
        next_probe: string | null;
      } | null;
    };
    download: {
      __typename: "DownloadBundle";
      id: string;
      created: string;
      started: string | null;
      finished: string | null;
      status: string;
      handle: any;
      progress: any;
      report_datetime: {
        __typename: "DateTimeHuman";
        short: string;
        long: string;
        long_utc: string;
        iso: string;
      } | null;
    } | null;
    download_part: {
      __typename: "DownloadPart";
      id: string;
      row_count: number | null;
      dirty_row_count: number | null;
      dirty_row_status: string | null;
      legacy_flow_source_id: string | null;
      download: { __typename: "DownloadBundle"; id: string; handle: any; status: string; finished: string | null };
    } | null;
  } | null>;
  processing: {
    __typename: "Processing";
    id: string;
    started: string | null;
    finished: string | null;
    status: string;
  } | null;
  outputs: Array<{
    __typename: "FlowOutput";
    id: string;
    name: string;
    project: string;
    handle: any;
    row_count: number | null;
    created: string | null;
    started: string | null;
    finished: string | null;
    status: string | null;
    report_datetime: { __typename: "DateTimeHuman"; short: string; long: string; long_utc: string; iso: string } | null;
    declaration: { __typename: "ExportDeclaration"; id: string };
  } | null>;
  events: Array<{
    __typename: "Event";
    id: string;
    created: string;
    message: string | null;
    severity: string | null;
    project_name: string | null;
    will_retry: boolean | null;
    comment: string | null;
    commented_on: string | null;
    download: { __typename: "DownloadBundle"; id: string } | null;
    flow: { __typename: "FlowSE"; id: string } | null;
    upload: { __typename: "Upload"; id: string } | null;
    commented_by: { __typename: "User"; name: string } | null;
  } | null>;
};

export type SaveDownloadMutationVariables = Exact<{
  id: string;
  status: string;
}>;

export type SaveDownloadMutation = {
  __typename: "Mutation";
  save_download: { __typename: "SaveDownloadBundle"; ok: boolean } | null;
};

export type SaveUploadMutationVariables = Exact<{
  id: string;
  status: string;
}>;

export type SaveUploadMutation = {
  __typename: "Mutation";
  save_upload: { __typename: "SaveUpload"; ok: boolean } | null;
};

export type SaveAccountV2MutationVariables = Exact<{
  urlName?: string | null | undefined;
  name?: string | null | undefined;
  newUrlName?: string | null | undefined;
  setDefaultDeadline?: string | null | undefined;
  removeDefaultDeadline?: boolean | null | undefined;
  setSummaryTime?: string | null | undefined;
  removeSummaryTime?: boolean | null | undefined;
  setSummaryRecipients?: Array<string> | string | null | undefined;
  clearSummaryRecipients?: boolean | null | undefined;
  showDownloadSummary?: boolean | null | undefined;
  contractedRowCount?: number | null | undefined;
}>;

export type SaveAccountV2Mutation = {
  __typename: "Mutation";
  saveAccountV2:
    | { __typename: "ResultOk"; ok: boolean | null }
    | {
        __typename: "SaveAccountErrors";
        errors: Array<
          | { __typename: "ConflictingNameError"; message: string }
          | { __typename: "ConflictingUrlNameError"; message: string }
          | null
        > | null;
      };
};

export type DeactivateAccountV2MutationVariables = Exact<{
  urlName: string;
}>;

export type DeactivateAccountV2Mutation = {
  __typename: "Mutation";
  deactivateAccountV2: { __typename: "DeactivateAccountV2"; ok: boolean } | null;
};

export type ResetAuth0PasswordMutationVariables = Exact<{
  email: string;
}>;

export type ResetAuth0PasswordMutation = {
  __typename: "Mutation";
  resetAuth0Password: { __typename: "ResetAuth0Password"; ok: boolean } | null;
};

export type SetAuth0UserBlockMutationVariables = Exact<{
  id: string;
  blocked: boolean;
}>;

export type SetAuth0UserBlockMutation = {
  __typename: "Mutation";
  setAuth0UserBlock: { __typename: "SetUserBlock"; ok: boolean } | null;
};

export type BackfillMutationVariables = Exact<{
  name: string;
  since: string;
  until: string;
}>;

export type BackfillMutation = {
  __typename: "Mutation";
  backfill_source_bundle: { __typename: "BackfillSourceBundle"; ok: boolean; handles: Array<any> } | null;
};

export type LaunchBackfillMutationVariables = Exact<{
  upload_names: Array<string> | string;
  title: string;
  description: string;
  start_datetime: string;
  end_datetime: string;
}>;

export type LaunchBackfillMutation = {
  __typename: "Mutation";
  launch_backfill:
    | {
        __typename: "Backfill";
        id: string;
        status: string;
        start_datetime: string;
        end_datetime: string;
        upload_names: Array<string>;
        download_names: Array<string>;
        title: string;
        description: string;
        total_pipelines: number | null;
        succeeded_pipelines: number | null;
        failed_pipelines: number | null;
        created_by: { __typename: "User"; name: string; email: string };
        cancelled_by: { __typename: "User"; name: string; email: string } | null;
        changelist: { __typename: "Changelist"; id: string };
        subgraph: { __typename: "Subgraph"; id: string };
      }
    | {
        __typename: "ConflictingBackfillsError";
        conflicting_backfills: Array<{ __typename: "Backfill"; id: string; title: string }>;
      }
    | null;
};

export type SaveBackfillMutationVariables = Exact<{
  backfill_id: string;
  status?: string | null | undefined;
  title?: string | null | undefined;
  description?: string | null | undefined;
}>;

export type SaveBackfillMutation = {
  __typename: "Mutation";
  save_backfill: { __typename: "Backfill"; id: string; status: string; title: string; description: string };
};

export type SaveChangelistMutationVariables = Exact<{
  changelist_id?: string | null | undefined;
  action?: string | null | undefined;
}>;

export type SaveChangelistMutation = {
  __typename: "Mutation";
  save_changelist:
    | { __typename: "NeedsMergeError" }
    | {
        __typename: "SaveChangelistOk";
        changelist: {
          __typename: "Changelist";
          id: string;
          description: string;
          created_on: string;
          updated_on: string;
          status: string;
        } | null;
      }
    | null;
};

export type BranchChangelistMutationVariables = Exact<{
  description: string;
  changelist_id?: string | null | undefined;
}>;

export type BranchChangelistMutation = {
  __typename: "Mutation";
  branch_changelist: {
    __typename: "SaveChangelistOk";
    changelist: {
      __typename: "Changelist";
      id: string;
      description: string;
      created_on: string;
      updated_on: string;
      status: string;
    } | null;
  } | null;
};

export type RenameChangelistMutationVariables = Exact<{
  changelist_id?: string | null | undefined;
  changelist?: Types.SaveChangelistInput | null | undefined;
}>;

export type RenameChangelistMutation = {
  __typename: "Mutation";
  save_changelist:
    | { __typename: "NeedsMergeError" }
    | { __typename: "SaveChangelistOk"; changelist: { __typename: "Changelist"; description: string } | null }
    | null;
};

export type UpdateChangelistMutationVariables = Exact<{
  changelist_id?: string | null | undefined;
  changelist?: Types.SaveChangelistInput | null | undefined;
  action?: string | null | undefined;
  fetch_new_downloads?: boolean | null | undefined;
  test_exports?: Array<string | null | undefined> | string | null | undefined;
  force_publish?: boolean | null | undefined;
}>;

export type UpdateChangelistMutation = {
  __typename: "Mutation";
  save_changelist:
    | { __typename: "NeedsMergeError"; message: string }
    | {
        __typename: "SaveChangelistOk";
        action: string | null;
        changelist: {
          __typename: "Changelist";
          description: string;
          files: Array<{ __typename: "File"; path: string }>;
          compilation_result: {
            __typename: "CompilationResult";
            declarations: Array<{
              __typename: "CompilationDeclaration";
              name: string;
              connector_type: string;
              path: string;
              line: number;
              column: number;
              declaration_type: string;
              test: boolean;
              key_name: string | null;
            }> | null;
            messages: Array<{
              __typename: "CompilationMessage";
              type: string;
              path: string;
              line: number;
              column: number;
              message: string;
              startLine: number;
              startColumn: number;
              endLine: number;
              endColumn: number;
            }> | null;
          } | null;
        } | null;
      }
    | null;
};

export type SaveCredentialMutationVariables = Exact<{
  name?: string | null | undefined;
  new_name?: string | null | undefined;
  credential_type?: string | null | undefined;
  status?: string | null | undefined;
  properties?: any;
  replace_properties?: boolean | null | undefined;
}>;

export type SaveCredentialMutation = {
  __typename: "Mutation";
  save_credential:
    | { __typename: "InvalidCredential"; message: string }
    | {
        __typename: "SaveCredentialOk";
        ok: boolean | null;
        credential: { __typename: "Credential"; name: string } | null;
      }
    | {
        __typename: "ValidationErrors";
        errors: Array<{ __typename: "ValidationError"; typeId: string; properties: any } | null> | null;
      }
    | null;
};

export type SaveIntegrationMutationVariables = Exact<{
  id?: string | null | undefined;
  integration_type?: string | null | undefined;
  authorization?: any;
  configuration?: any;
  filters?: Array<Types.IntegrationFilterInput | null | undefined> | Types.IntegrationFilterInput | null | undefined;
}>;

export type SaveIntegrationMutation = {
  __typename: "Mutation";
  save_integration: {
    __typename: "SaveIntegration";
    ok: boolean;
    integration: {
      __typename: "Integration";
      id: string;
      integration_type: string;
      public_authorization: any;
      configuration: any;
      status: string;
      assistance: any;
      filters: Array<{
        __typename: "IntegrationFilter";
        id: string;
        production: boolean;
        backfills: boolean;
        proofs: boolean;
        lateUploads: boolean;
        beta: boolean;
        configuration: any;
        status: string;
      } | null>;
    };
  } | null;
};

export type RemoveIntegrationMutationVariables = Exact<{
  id: string;
}>;

export type RemoveIntegrationMutation = {
  __typename: "Mutation";
  remove_integration: { __typename: "RemoveIntegration"; ok: boolean } | null;
};

export type SaveSourceBundleMutationVariables = Exact<{
  name: string;
  status?: string | null | undefined;
}>;

export type SaveSourceBundleMutation = {
  __typename: "Mutation";
  save_source_bundle: { __typename: "SaveSourceBundle"; ok: boolean } | null;
};

export type SaveExportMutationVariables = Exact<{
  name: string;
  status?: string | null | undefined;
}>;

export type SaveExportMutation = {
  __typename: "Mutation";
  save_export: { __typename: "SaveExport"; ok: boolean } | null;
};

export type ArchiveTestMutationVariables = Exact<{
  id: string;
}>;

export type ArchiveTestMutation = { __typename: "Mutation"; save_flow: { __typename: "SaveFlow"; ok: boolean } | null };

export type SaveUserMutationVariables = Exact<{
  urlNames?: Array<string> | string | null | undefined;
  roles?: Array<string> | string | null | undefined;
  email?: string | null | undefined;
  userEmail?: string | null | undefined;
  userName?: string | null | undefined;
  userPassword?: string | null | undefined;
  blocked?: boolean | null | undefined;
}>;

export type SaveUserMutation = {
  __typename: "Mutation";
  saveUserV2:
    | {
        __typename: "SaveUserErrors";
        errors: Array<
          | { __typename: "ConflictingEmailError"; message: string }
          | { __typename: "InsecurePasswordError"; message: string; passwordErrors: Array<string> | null }
        > | null;
      }
    | {
        __typename: "SaveUserSuccessMutationResult";
        ok: boolean | null;
        user: {
          __typename: "UserDetailV2";
          id: string;
          email: string;
          name: string;
          globalRoles: Array<string> | null;
          accounts: Array<{
            __typename: "UserAccounts";
            id: string;
            urlName: string;
            name: string;
            roles: Array<string>;
          }>;
        } | null;
      };
};

export type RemoveUserV2MutationVariables = Exact<{
  email: string;
  urlName?: string | null | undefined;
}>;

export type RemoveUserV2Mutation = {
  __typename: "Mutation";
  removeUserV2:
    | {
        __typename: "RemoveUserV2Errors";
        errors: Array<{ __typename: "AttachedToMoreAccountsError"; message: string }> | null;
      }
    | { __typename: "ResultOk"; ok: boolean | null };
};

export type AccountsV2QueryVariables = Exact<{
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type AccountsV2Query = {
  __typename: "Query";
  accountsV2: {
    __typename: "AccountV2Connection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{ __typename: "AccountV2Edge"; node: { __typename: "AccountV2"; name: string; urlName: string } }>;
  } | null;
};

export type AccountQueryVariables = Exact<{
  urlName: string;
}>;

export type AccountQuery = {
  __typename: "Query";
  account: {
    __typename: "AccountDetail";
    name: string;
    urlName: string;
    defaultDeadline: string | null;
    dailySummaryTime: string | null;
    dailySummaryRecipients: any;
    contractedRowCount: number | null;
    showDownloadSummary: boolean | null;
    users: Array<{ __typename: "AccountLoginDetail"; email: string; name: string; roles: Array<string> }>;
  } | null;
};

export type VerifyEmailQueryVariables = Exact<{
  email: string;
}>;

export type VerifyEmailQuery = {
  __typename: "Query";
  verifyEmail: {
    __typename: "VerifyEmail";
    auth0Name: string | null;
    userId: string | null;
    useIdP: boolean | null;
  } | null;
};

export type BackfillsQueryVariables = Exact<{
  id?: string | null | undefined;
  ids?: Array<string | null | undefined> | string | null | undefined;
  status?: string | null | undefined;
  report_datetime_after?: string | null | undefined;
  report_datetime_before?: string | null | undefined;
  created_datetime_after?: string | null | undefined;
  created_datetime_before?: string | null | undefined;
  search?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type BackfillsQuery = {
  __typename: "Query";
  backfills: {
    __typename: "BackfillConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "BackfillEdge";
      cursor: string;
      node: {
        __typename: "Backfill";
        id: string;
        status: string;
        title: string;
        upload_names: Array<string>;
        download_names: Array<string>;
        created_on: string;
        cancelled_on: string | null;
        start_datetime: string;
        end_datetime: string;
        total_pipelines: number | null;
        succeeded_pipelines: number | null;
        failed_pipelines: number | null;
        cancelled_pipelines: number | null;
        hasDirtyRows: boolean | null;
        created_by: { __typename: "User"; name: string; email: string };
        cancelled_by: { __typename: "User"; name: string; email: string } | null;
      };
    }>;
  } | null;
};

export type BackfillDetailQueryVariables = Exact<{
  backfill_id: string;
}>;

export type BackfillDetailQuery = {
  __typename: "Query";
  backfill: {
    __typename: "Backfill";
    id: string;
    status: string;
    title: string;
    start_datetime: string;
    end_datetime: string;
    description: string;
    cancelled_pipelines: number | null;
    total_pipelines: number | null;
    succeeded_pipelines: number | null;
    failed_pipelines: number | null;
    download_names: Array<string>;
    upload_names: Array<string>;
    created_on: string;
    cancelled_on: string | null;
    hasDirtyRows: boolean | null;
    created_by: { __typename: "User"; name: string; email: string };
    cancelled_by: { __typename: "User"; name: string; email: string } | null;
    subgraph: {
      __typename: "Subgraph";
      download_declarations: Array<{
        __typename: "SourceBundle";
        bundle_name: string | null;
        tables: Array<{
          __typename: "SourceTable";
          name: string;
          exports: Array<{ __typename: "ExportDeclaration"; name: string } | null>;
        } | null>;
      } | null>;
      upload_declarations: Array<{ __typename: "ExportDeclaration"; name: string } | null>;
    };
  };
};

export type BackfillFlowsQueryVariables = Exact<{
  backfill_id?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
  status?: string | null | undefined;
  phase?: string | null | undefined;
  sortDirection?: Types.SortDirection | null | undefined;
}>;

export type BackfillFlowsQuery = {
  __typename: "Query";
  flows: {
    __typename: "FlowConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "FlowEdge";
      cursor: string;
      node: {
        __typename: "Flow";
        id: string;
        created: string;
        failed: boolean;
        phase: string;
        status: string;
        changelist: { __typename: "Changelist"; id: string; description: string };
        launched_by: { __typename: "User"; name: string; email: string };
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
        inputs: Array<{
          __typename: "FlowInput";
          name: string;
          source_table: {
            __typename: "SourceTable";
            id: string;
            name: string;
            project: string;
            bundle: {
              __typename: "SourceBundle";
              report_handle: any;
              recent_failed_probe: string | null;
              recent_successful_probe: string | null;
              next_probe: string | null;
            } | null;
          };
          download: {
            __typename: "DownloadBundle";
            id: string;
            created: string;
            started: string | null;
            finished: string | null;
            status: string;
            handle: any;
            progress: any;
            report_datetime: {
              __typename: "DateTimeHuman";
              short: string;
              long: string;
              long_utc: string;
              iso: string;
            } | null;
          } | null;
          download_part: {
            __typename: "DownloadPart";
            id: string;
            row_count: number | null;
            dirty_row_count: number | null;
            dirty_row_status: string | null;
            legacy_flow_source_id: string | null;
            download: {
              __typename: "DownloadBundle";
              id: string;
              handle: any;
              status: string;
              finished: string | null;
            };
          } | null;
        } | null>;
        processing: {
          __typename: "Processing";
          id: string;
          started: string | null;
          finished: string | null;
          status: string;
        } | null;
        outputs: Array<{
          __typename: "FlowOutput";
          id: string;
          name: string;
          project: string;
          handle: any;
          row_count: number | null;
          created: string | null;
          started: string | null;
          finished: string | null;
          status: string | null;
          report_datetime: {
            __typename: "DateTimeHuman";
            short: string;
            long: string;
            long_utc: string;
            iso: string;
          } | null;
          declaration: { __typename: "ExportDeclaration"; id: string };
        } | null>;
      };
    }>;
  } | null;
};

export type BackfillMessagesQueryVariables = Exact<{
  backfill_id?: string | null | undefined;
  search?: string | null | undefined;
  created_before?: string | null | undefined;
  created_after?: string | null | undefined;
  severity?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type BackfillMessagesQuery = {
  __typename: "Query";
  events: {
    __typename: "EventConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "EventEdge";
      node: {
        __typename: "Event";
        id: string;
        created: string;
        severity: string | null;
        message: string | null;
        project_name: string | null;
        will_retry: boolean | null;
        comment: string | null;
        commented_on: string | null;
        download: { __typename: "DownloadBundle"; id: string } | null;
        flow: { __typename: "FlowSE"; id: string } | null;
        upload: { __typename: "Upload"; id: string } | null;
        commented_by: { __typename: "User"; name: string } | null;
      };
    }>;
  } | null;
};

export type PublishedChangelistQueryVariables = Exact<{ [key: string]: never }>;

export type PublishedChangelistQuery = {
  __typename: "Query";
  changelist: {
    __typename: "Changelist";
    id: string;
    description: string;
    published_on: string | null;
    status: string;
    published_by: { __typename: "User"; name: string; email: string } | null;
  } | null;
};

export type QueryChangelistFileQueryVariables = Exact<{
  id?: string | null | undefined;
  opened_paths?: Array<string | null | undefined> | string | null | undefined;
}>;

export type QueryChangelistFileQuery = {
  __typename: "Query";
  changelist: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    opened_files: Array<{ __typename: "File"; id: string; path: string; text: string }>;
  } | null;
};

export type DiffViewQueryVariables = Exact<{
  draft_id: string;
}>;

export type DiffViewQuery = {
  __typename: "Query";
  currentDraft: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    all_files: Array<{ __typename: "File"; id: string; path: string }>;
    compilation_result: {
      __typename: "CompilationResult";
      declarations: Array<{
        __typename: "CompilationDeclaration";
        name: string;
        connector_type: string;
        path: string;
        line: number;
        column: number;
        declaration_type: string;
        test: boolean;
        key_name: string | null;
      }> | null;
      messages: Array<{
        __typename: "CompilationMessage";
        type: string;
        path: string;
        line: number;
        column: number;
        message: string;
        startLine: number;
        endLine: number;
        startColumn: number;
        endColumn: number;
      }> | null;
    } | null;
    flow_summary: {
      __typename: "FlowSummary";
      purpose: string;
      unfinished: number;
      succeeded: number;
      failed: number;
      dirty_rows_all: number;
      dirty_rows_some: number;
    } | null;
  } | null;
  publishedDraft: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    all_files: Array<{ __typename: "File"; id: string; path: string }>;
  } | null;
};

export type DiffOpenFilesQueryVariables = Exact<{
  draft_id: string;
  published_id: string;
  draft_opened_paths?: Array<string | null | undefined> | string | null | undefined;
  published_opened_paths?: Array<string | null | undefined> | string | null | undefined;
}>;

export type DiffOpenFilesQuery = {
  __typename: "Query";
  currentDraft: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    opened_files: Array<{ __typename: "File"; id: string; path: string; text: string }>;
  } | null;
  publishedDraft: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    opened_files: Array<{ __typename: "File"; id: string; path: string; text: string }>;
  } | null;
};

export type PublishedDiffOpenFilesQueryVariables = Exact<{
  draft_id: string;
  draft_opened_paths?: Array<string | null | undefined> | string | null | undefined;
  published_opened_paths?: Array<string | null | undefined> | string | null | undefined;
}>;

export type PublishedDiffOpenFilesQuery = {
  __typename: "Query";
  currentDraft: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    opened_files: Array<{ __typename: "File"; id: string; path: string; text: string }>;
  } | null;
  publishedDraft: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    opened_files: Array<{ __typename: "File"; id: string; path: string; text: string }>;
  } | null;
};

export type ChangelistDiffFilesQueryVariables = Exact<{
  original_id?: string | null | undefined;
  modified_id: string;
}>;

export type ChangelistDiffFilesQuery = {
  __typename: "Query";
  changelist_diff: {
    __typename: "ChangelistDiff";
    unchanged_files: Array<string>;
    modified_files: Array<string>;
    deleted_files: Array<string>;
    created_files: Array<string>;
  } | null;
};

export type QueryJustChangelistQueryVariables = Exact<{
  id?: string | null | undefined;
}>;

export type QueryJustChangelistQuery = {
  __typename: "Query";
  changelist: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    all_files: Array<{ __typename: "File"; id: string; path: string }>;
    compilation_result: {
      __typename: "CompilationResult";
      declarations: Array<{
        __typename: "CompilationDeclaration";
        name: string;
        connector_type: string;
        path: string;
        line: number;
        column: number;
        declaration_type: string;
        test: boolean;
        key_name: string | null;
      }> | null;
      messages: Array<{
        __typename: "CompilationMessage";
        type: string;
        path: string;
        line: number;
        column: number;
        message: string;
        startLine: number;
        startColumn: number;
        endLine: number;
        endColumn: number;
      }> | null;
    } | null;
    flow_summary: {
      __typename: "FlowSummary";
      purpose: string;
      unfinished: number;
      succeeded: number;
      failed: number;
      dirty_rows_all: number;
      dirty_rows_some: number;
    } | null;
  } | null;
};

export type ChangelistOutdatedQueryVariables = Exact<{
  id?: string | null | undefined;
}>;

export type ChangelistOutdatedQuery = {
  __typename: "Query";
  changelist: { __typename: "Changelist"; needs_merge: boolean | null } | null;
};

export type CredentialQueryVariables = Exact<{
  name: string;
}>;

export type CredentialQuery = {
  __typename: "Query";
  credential: {
    __typename: "Credential";
    id: number | null;
    name: string;
    credential_type: string;
    properties: any;
    properties_exist: any;
    status: string;
  } | null;
};

export type CredentialOauthQueryVariables = Exact<{
  name: string;
  credential_type?: string | null | undefined;
}>;

export type CredentialOauthQuery = {
  __typename: "Query";
  credential: { __typename: "Credential"; name: string; exist: boolean | null } | null;
};

export type CredentialsQueryVariables = Exact<{
  first?: number | null | undefined;
  after?: string | null | undefined;
  credentialTypes?: Array<string> | string | null | undefined;
  search?: string | null | undefined;
  statusFilters?: Array<string> | string | null | undefined;
  sortBy?: string | null | undefined;
  sortDirection?: string | null | undefined;
}>;

export type CredentialsQuery = {
  __typename: "Query";
  credentials: {
    __typename: "CredentialConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "CredentialEdge";
      cursor: string;
      node: {
        __typename: "Credential";
        name: string;
        credential_type: string;
        status: string;
        properties: any;
        description: string | null;
      };
    }>;
  } | null;
};

export type GetSuspendedCredentialCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetSuspendedCredentialCountQuery = { __typename: "Query"; getSuspendedCredentialCount: number | null };

export type GetDataFlowQueryVariables = Exact<{ [key: string]: never }>;

export type GetDataFlowQuery = {
  __typename: "Query";
  getDataFlow: {
    __typename: "PipelinesType";
    scriptbookId: string | null;
    scriptbookDescription: string | null;
    steps: Array<{
      __typename: "Step";
      kind: Types.StepKind;
      name: string;
      declarationName: string;
      project: string;
      line: number;
      sourceTables: Array<string>;
      destTables: Array<string>;
      inputs: Array<string> | null;
      outputs: Array<string> | null;
    }>;
  } | null;
};

export type DownloadQueryVariables = Exact<{
  id: string;
}>;

export type DownloadQuery = {
  __typename: "Query";
  download: {
    __typename: "DownloadBundle";
    id: string;
    created: string;
    finished: string | null;
    handle: any;
    purpose: string;
    progress: any;
    started: string | null;
    status: string;
    report_datetime: { __typename: "DateTimeHuman"; short: string; long: string; long_utc: string; iso: string } | null;
    source_tables: Array<{ __typename: "SourceTable"; name: string; project: string } | null>;
    parts: Array<{
      __typename: "DownloadPart";
      id: string;
      dirty_row_count: number | null;
      dirty_row_status: string | null;
      legacy_flow_source_id: string | null;
      row_count: number | null;
      hasConnectedUploadDeclarations: boolean | null;
      source_table: { __typename: "SourceTable"; name: string; project: string };
    } | null> | null;
  } | null;
};

export type FlowDownloadsQueryVariables = Exact<{
  id: string;
}>;

export type FlowDownloadsQuery = {
  __typename: "Query";
  flow_downloads: {
    __typename: "DownloadBundleConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "DownloadBundleEdge";
      cursor: string;
      node: {
        __typename: "DownloadBundle";
        id: string;
        created: string;
        finished: string | null;
        handle: any;
        purpose: string;
        progress: any;
        started: string | null;
        status: string;
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
        source_tables: Array<{ __typename: "SourceTable"; name: string; project: string } | null>;
        parts: Array<{
          __typename: "DownloadPart";
          id: string;
          dirty_row_count: number | null;
          dirty_row_status: string | null;
          legacy_flow_source_id: string | null;
          row_count: number | null;
          source_table: { __typename: "SourceTable"; name: string; project: string };
        } | null> | null;
      };
    }>;
  } | null;
};

export type DownloadsQueryVariables = Exact<{
  dirty?: boolean | null | undefined;
  dirtyEqualsNewDirty?: boolean | null | undefined;
  newDirtyGreaterThanDirty?: boolean | null | undefined;
  downloaded_after?: string | null | undefined;
  downloaded_before?: string | null | undefined;
  name?: string | null | undefined;
  names?: Array<string | null | undefined> | string | null | undefined;
  bundle_name?: string | null | undefined;
  bundleNames?: Array<string | null | undefined> | string | null | undefined;
  project?: string | null | undefined;
  projects?: Array<string | null | undefined> | string | null | undefined;
  purpose?: string | null | undefined;
  report_datetime_after?: string | null | undefined;
  report_datetime_before?: string | null | undefined;
  search?: string | null | undefined;
  status?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
  sortBy?: Types.DataGridSortableColumns | null | undefined;
  sortDirection?: Types.SortDirection | null | undefined;
}>;

export type DownloadsQuery = {
  __typename: "Query";
  downloads: {
    __typename: "DownloadBundleConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "DownloadBundleEdge";
      cursor: string;
      node: {
        __typename: "DownloadBundle";
        id: string;
        created: string;
        finished: string | null;
        handle: any;
        purpose: string;
        progress: any;
        started: string | null;
        status: string;
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
        source_tables: Array<{ __typename: "SourceTable"; id: string; name: string; project: string } | null>;
        parts: Array<{
          __typename: "DownloadPart";
          id: string;
          dirty_row_count: number | null;
          dirty_row_status: string | null;
          new_dirty_row_count: number | null;
          new_dirty_row_status: string | null;
          legacy_flow_source_id: string | null;
          row_count: number | null;
          hasConnectedUploadDeclarations: boolean | null;
          source_table: { __typename: "SourceTable"; name: string; project: string };
        } | null> | null;
      };
    }>;
  } | null;
};

export type DraftsQueryVariables = Exact<{
  archived?: boolean | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type DraftsQuery = {
  __typename: "Query";
  drafts: {
    __typename: "ChangelistConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "ChangelistEdge";
      cursor: string;
      node: {
        __typename: "Changelist";
        id: string;
        description: string;
        created_on: string;
        updated_on: string;
        published_on: string | null;
        status: string;
        archived: boolean;
        needs_merge: boolean | null;
        branched_from: string | null;
        created_by: { __typename: "User"; name: string; email: string };
        updated_by: { __typename: "User"; name: string; email: string };
        published_by: { __typename: "User"; name: string; email: string } | null;
        flow_summary: {
          __typename: "FlowSummary";
          purpose: string;
          unfinished: number;
          succeeded: number;
          failed: number;
          dirty_rows_all: number;
          dirty_rows_some: number;
        } | null;
      };
    }>;
  } | null;
};

export type PublishedDraftQueryVariables = Exact<{ [key: string]: never }>;

export type PublishedDraftQuery = {
  __typename: "Query";
  changelist: {
    __typename: "Changelist";
    id: string;
    description: string;
    created_on: string;
    updated_on: string;
    published_on: string | null;
    status: string;
    created_by: { __typename: "User"; name: string; email: string };
    updated_by: { __typename: "User"; name: string; email: string };
    published_by: { __typename: "User"; name: string; email: string } | null;
  } | null;
};

export type QueryFullEditorPageQueryVariables = Exact<{
  id?: string | null | undefined;
  first?: number | null | undefined;
}>;

export type QueryFullEditorPageQuery = {
  __typename: "Query";
  credentials: {
    __typename: "CredentialConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "CredentialEdge";
      cursor: string;
      node: { __typename: "Credential"; name: string; credential_type: string; status: string };
    }>;
  } | null;
  changelist: {
    __typename: "Changelist";
    id: string;
    description: string;
    status: string;
    archived: boolean;
    needs_merge: boolean | null;
    all_files: Array<{ __typename: "File"; id: string; path: string }>;
    compilation_result: {
      __typename: "CompilationResult";
      declarations: Array<{
        __typename: "CompilationDeclaration";
        name: string;
        connector_type: string;
        path: string;
        line: number;
        column: number;
        declaration_type: string;
        test: boolean;
        key_name: string | null;
      }> | null;
      messages: Array<{
        __typename: "CompilationMessage";
        type: string;
        path: string;
        line: number;
        column: number;
        message: string;
        startLine: number;
        startColumn: number;
        endLine: number;
        endColumn: number;
      }> | null;
    } | null;
    flow_summary: {
      __typename: "FlowSummary";
      purpose: string;
      unfinished: number;
      succeeded: number;
      failed: number;
      dirty_rows_all: number;
      dirty_rows_some: number;
    } | null;
  } | null;
  sbs_schemas: Array<{ __typename: "SbsSchema"; name: string } | null> | null;
};

export type QueryCompilationResultQueryVariables = Exact<{
  id?: string | null | undefined;
}>;

export type QueryCompilationResultQuery = {
  __typename: "Query";
  changelist: {
    __typename: "Changelist";
    needs_merge: boolean | null;
    compilation_result: {
      __typename: "CompilationResult";
      declarations: Array<{
        __typename: "CompilationDeclaration";
        name: string;
        connector_type: string;
        path: string;
        line: number;
        column: number;
        declaration_type: string;
        test: boolean;
        key_name: string | null;
      }> | null;
      messages: Array<{
        __typename: "CompilationMessage";
        type: string;
        path: string;
        line: number;
        column: number;
        message: string;
        startLine: number;
        startColumn: number;
        endLine: number;
        endColumn: number;
      }> | null;
    } | null;
  } | null;
};

export type EmailRecipientsQueryVariables = Exact<{ [key: string]: never }>;

export type EmailRecipientsQuery = {
  __typename: "Query";
  recipients: Array<{
    __typename: "Recipient";
    email: string;
    rules: Array<{
      __typename: "Rule";
      id: string;
      senderGlob: string | null;
      subjectGlob: string | null;
      senderRegex: string | null;
      subjectRegex: string | null;
      path: string;
      matchOrder: number;
    }>;
  }> | null;
};

export type SaveEmailMatchMutationVariables = Exact<{
  id?: string | null | undefined;
  recipient?: string | null | undefined;
  deactivate?: boolean | null | undefined;
  rule?: Types.RuleInput | null | undefined;
}>;

export type SaveEmailMatchMutation = {
  __typename: "Mutation";
  save_emailmatch:
    | { __typename: "InvalidPathError"; field: string; message: string }
    | { __typename: "InvalidRegexError"; field: string; message: string }
    | {
        __typename: "SaveEmailMatchOk";
        email: string;
        rules: Array<{
          __typename: "Rule";
          id: string;
          senderGlob: string | null;
          subjectGlob: string | null;
          senderRegex: string | null;
          subjectRegex: string | null;
          path: string;
          matchOrder: number;
        }>;
      }
    | null;
};

export type SaveEmailRecipientMutationVariables = Exact<{
  recipient: string;
  newRecipient?: string | null | undefined;
  deactivate?: boolean | null | undefined;
}>;

export type SaveEmailRecipientMutation = {
  __typename: "Mutation";
  save_emailrecipient:
    | { __typename: "RecipientAlreadyExistsError"; field: string; message: string }
    | { __typename: "SaveEmailRecipientOk"; newEmail: string | null; oldEmail: string }
    | null;
};

export type EventsQueryVariables = Exact<{
  severity?: string | null | undefined;
  severities?: Array<string | null | undefined> | string | null | undefined;
  search?: string | null | undefined;
  report_datetime_after?: string | null | undefined;
  report_datetime_before?: string | null | undefined;
  created_after?: string | null | undefined;
  created_before?: string | null | undefined;
  withComments?: boolean | null | undefined;
  projectNames?: Array<string | null | undefined> | string | null | undefined;
  downloadNames?: Array<string | null | undefined> | string | null | undefined;
  uploadNames?: Array<string | null | undefined> | string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type EventsQuery = {
  __typename: "Query";
  events: {
    __typename: "EventConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "EventEdge";
      cursor: string;
      node: {
        __typename: "Event";
        id: string;
        report_datetime: string | null;
        created: string;
        severity: string | null;
        message: string | null;
        project_name: string | null;
        will_retry: boolean | null;
        comment: string | null;
        commented_on: string | null;
        retry_count: number | null;
        retry_limit: number | null;
        download: { __typename: "DownloadBundle"; id: string } | null;
        flow: { __typename: "FlowSE"; id: string } | null;
        upload: { __typename: "Upload"; id: string } | null;
        commented_by: { __typename: "User"; name: string } | null;
        download_declaration: { __typename: "SourceTable"; name: string } | null;
        upload_declaration: { __typename: "ExportDeclaration"; name: string } | null;
      };
    }>;
  } | null;
};

export type UpdateCommentMutationVariables = Exact<{
  id: string;
  comment?: string | null | undefined;
}>;

export type UpdateCommentMutation = {
  __typename: "Mutation";
  save_event: { __typename: "SaveEvent"; ok: boolean; event: { __typename: "Event"; comment: string | null } } | null;
};

export type HistoryQueryVariables = Exact<{
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type HistoryQuery = {
  __typename: "Query";
  history: {
    __typename: "ChangelistConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "ChangelistEdge";
      cursor: string;
      node: {
        __typename: "Changelist";
        id: string;
        description: string;
        created_on: string;
        updated_on: string;
        published_on: string | null;
        status: string;
        archived: boolean;
        created_by: { __typename: "User"; name: string; email: string };
        published_by: { __typename: "User"; name: string; email: string } | null;
      };
    }>;
  } | null;
};

export type HomepageQueryVariables = Exact<{
  refresh: boolean;
}>;

export type HomepageQuery = {
  __typename: "Query";
  homepage:
    | {
        __typename: "Homepage";
        refreshedAt: string;
        sparklineFirstDate: string;
        downloads: Array<{
          __typename: "HomepageDownloadSummary";
          dependencyStatus: string;
          artifactStatus: string;
          name: string;
          event: {
            __typename: "HomepageEvent";
            created: string;
            eventId: string;
            message: string;
            purpose: string;
            qualname: string;
            severity: string;
            willRetry: boolean;
          } | null;
          pos: {
            __typename: "Position";
            endColumn: number;
            endLine: number;
            path: string;
            startColumn: number;
            startLine: number;
          };
          sparkline: Array<{ __typename: "HomepageSparklineDay"; status: string; running: boolean }>;
        }>;
        uploads: Array<{
          __typename: "HomepageUploadSummary";
          dependencyStatus: string;
          artifactStatus: string;
          name: string;
          destination: string | null;
          event: {
            __typename: "HomepageEvent";
            created: string;
            eventId: string;
            message: string;
            purpose: string;
            qualname: string;
            severity: string;
            willRetry: boolean;
          } | null;
          pos: {
            __typename: "Position";
            endColumn: number;
            endLine: number;
            path: string;
            startColumn: number;
            startLine: number;
          };
          sparkline: Array<{ __typename: "HomepageSparklineDay"; status: string; running: boolean }>;
        }>;
      }
    | { __typename: "NoPublishedScriptbook"; ok: boolean };
};

export type DownloadDetailsQueryVariables = Exact<{
  downloadName: string;
  refresh?: boolean | null | undefined;
}>;

export type DownloadDetailsQuery = {
  __typename: "Query";
  downloadDetails: {
    __typename: "DownloadDetails";
    status: string;
    refreshedAt: string;
    sparklineFirstDate: string;
    scriptbookId: string;
    event: {
      __typename: "HomepageEvent";
      created: string;
      eventId: string;
      message: string;
      purpose: string;
      qualname: string;
      severity: string;
      willRetry: boolean;
    } | null;
    pos: {
      __typename: "Position";
      endColumn: number;
      endLine: number;
      path: string;
      startColumn: number;
      startLine: number;
    };
    sparkline: Array<{ __typename: "HomepageSparklineDay"; running: boolean; status: string }>;
    keysUsedByDownload: Array<{ __typename: "KeyDependencySummary"; name: string; status: string }>;
    uploadsUsingDownload: Array<{ __typename: "UploadDependencySummary"; name: string; status: string }>;
  };
};

export type UploadDetailsQueryVariables = Exact<{
  uploadName: string;
  refresh?: boolean | null | undefined;
}>;

export type UploadDetailsQuery = {
  __typename: "Query";
  uploadDetails: {
    __typename: "UploadDetails";
    status: string;
    destination: string | null;
    refreshedAt: string;
    sparklineFirstDate: string;
    scriptbookId: string;
    event: {
      __typename: "HomepageEvent";
      created: string;
      eventId: string;
      message: string;
      purpose: string;
      qualname: string;
      severity: string;
      willRetry: boolean;
    } | null;
    pos: {
      __typename: "Position";
      endColumn: number;
      endLine: number;
      path: string;
      startColumn: number;
      startLine: number;
    };
    sparkline: Array<{ __typename: "HomepageSparklineDay"; running: boolean; status: string }>;
    keysUsedByUpload: Array<{ __typename: "KeyDependencySummary"; name: string; status: string }>;
    downloadsUsedByUpload: Array<{ __typename: "DownloadDependencySummary"; name: string; status: string }>;
  };
};

export type ImpactedAssetsCredentialQueryVariables = Exact<{
  credentialName: string;
}>;

export type ImpactedAssetsCredentialQuery = {
  __typename: "Query";
  impactedDownloads: {
    __typename: "SourceTableConnection";
    edges: Array<{ __typename: "SourceTableEdge"; node: { __typename: "SourceTable"; id: string; name: string } }>;
  } | null;
  impactedUploads: {
    __typename: "ExportDeclarationConnection";
    edges: Array<{
      __typename: "ExportDeclarationEdge";
      node: { __typename: "ExportDeclaration"; id: string; name: string };
    }>;
  } | null;
};

export type GetIntegrationQueryVariables = Exact<{
  id: string;
}>;

export type GetIntegrationQuery = {
  __typename: "Query";
  integration: {
    __typename: "Integration";
    id: string;
    integration_type: string;
    public_authorization: any;
    configuration: any;
    status: string;
    assistance: any;
    filters: Array<{
      __typename: "IntegrationFilter";
      id: string;
      production: boolean;
      backfills: boolean;
      proofs: boolean;
      lateUploads: boolean;
      configuration: any;
      status: string;
    } | null>;
  } | null;
};

export type GetIntegrationChannelQueryVariables = Exact<{
  id: string;
  channelId: string;
}>;

export type GetIntegrationChannelQuery = {
  __typename: "Query";
  integration: { __typename: "Integration"; id: string; channel_by_id: any } | null;
};

export type ListIntegrationsQueryVariables = Exact<{ [key: string]: never }>;

export type ListIntegrationsQuery = {
  __typename: "Query";
  integrations: {
    __typename: "IntegrationConnection";
    edges: Array<{
      __typename: "IntegrationEdge";
      node: {
        __typename: "Integration";
        id: string;
        integration_type: string;
        public_authorization: any;
        status: string;
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      startCursor: string | null;
      endCursor: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type StartOauthQueryVariables = Exact<{
  entity: string;
  oauthType: string;
  id?: string | null | undefined;
  name?: string | null | undefined;
}>;

export type StartOauthQuery = { __typename: "Query"; start_oauth: string | null };

export type StartKeyOauthQueryVariables = Exact<{
  entity: string;
  oauthType: string;
  id?: string | null | undefined;
  name: string;
}>;

export type StartKeyOauthQuery = {
  __typename: "Query";
  start_oauth: string | null;
  validateCredentialUniqueName:
    | { __typename: "ValidateCredentialOk"; ok: boolean | null }
    | {
        __typename: "ValidationErrors";
        errors: Array<{ __typename: "ValidationError"; typeId: string; properties: any } | null> | null;
      }
    | null;
};

export type KeyDetailsQueryVariables = Exact<{
  keyName: string;
}>;

export type KeyDetailsQuery = {
  __typename: "Query";
  keyDetails: {
    __typename: "KeyDetails";
    keyStatus: string;
    uploadsUsingKey: Array<{ __typename: "UploadDependencySummary"; name: string; status: string }>;
    downloadsUsingKey: Array<{ __typename: "DownloadDependencySummary"; name: string; status: string }>;
  };
};

export type UserPreferenceQueryVariables = Exact<{
  name: string;
}>;

export type UserPreferenceQuery = { __typename: "Query"; userPreference: any };

export type SavePreferenceMutationVariables = Exact<{
  name: string;
  value: any;
}>;

export type SavePreferenceMutation = {
  __typename: "Mutation";
  savePreference: { __typename: "SavePreference"; ok: boolean } | null;
};

export type ChangelistQueryVariables = Exact<{ [key: string]: never }>;

export type ChangelistQuery = {
  __typename: "Query";
  changelist: { __typename: "Changelist"; id: string; files: Array<{ __typename: "File"; path: string }> } | null;
};

export type PublishedSourceBundlesQueryVariables = Exact<{
  first?: number | null | undefined;
  can_backfill?: boolean | null | undefined;
}>;

export type PublishedSourceBundlesQuery = {
  __typename: "Query";
  source_bundles: {
    __typename: "SourceBundleConnection";
    edges: Array<{
      __typename: "SourceBundleEdge";
      node: {
        __typename: "SourceBundle";
        id: string;
        status: string;
        bundle_name: string | null;
        tables: Array<{
          __typename: "SourceTable";
          id: string;
          name: string;
          project: string;
          credential: { __typename: "Credential"; name: string; status: string } | null;
        } | null>;
      };
    }>;
  } | null;
};

export type ExportDeclarationsQueryVariables = Exact<{
  first?: number | null | undefined;
}>;

export type ExportDeclarationsQuery = {
  __typename: "Query";
  export_declarations: {
    __typename: "ExportDeclarationConnection";
    edges: Array<{
      __typename: "ExportDeclarationEdge";
      node: {
        __typename: "ExportDeclaration";
        name: string;
        project: string;
        status: string;
        destination: string | null;
        credential: { __typename: "Credential"; name: string; status: string } | null;
      };
    }>;
  } | null;
};

export type ExportDeclarationQueryVariables = Exact<{
  name?: string | null | undefined;
}>;

export type ExportDeclarationQuery = {
  __typename: "Query";
  export_declaration: {
    __typename: "ExportDeclaration";
    name: string;
    subgraph: {
      __typename: "Subgraph";
      download_declarations: Array<{
        __typename: "SourceBundle";
        bundle_name: string | null;
        tables: Array<{
          __typename: "SourceTable";
          name: string;
          exports: Array<{ __typename: "ExportDeclaration"; name: string } | null>;
        } | null>;
      } | null>;
      upload_declarations: Array<{ __typename: "ExportDeclaration"; name: string } | null>;
    } | null;
  } | null;
};

export type SuspendedAssetsQueryQueryVariables = Exact<{
  first?: number | null | undefined;
}>;

export type SuspendedAssetsQueryQuery = {
  __typename: "Query";
  changelist: { __typename: "Changelist"; id: string } | null;
  credentials: {
    __typename: "CredentialConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "CredentialEdge";
      cursor: string;
      node: { __typename: "Credential"; name: string; credential_type: string; status: string };
    }>;
  } | null;
  export_declarations: {
    __typename: "ExportDeclarationConnection";
    edges: Array<{
      __typename: "ExportDeclarationEdge";
      node: {
        __typename: "ExportDeclaration";
        id: string;
        name: string;
        project: string;
        line: number;
        status: string;
        credential: { __typename: "Credential"; name: string; status: string } | null;
      };
    }>;
  } | null;
  source_bundles: {
    __typename: "SourceBundleConnection";
    edges: Array<{
      __typename: "SourceBundleEdge";
      node: {
        __typename: "SourceBundle";
        id: string;
        status: string;
        tables: Array<{
          __typename: "SourceTable";
          id: string;
          name: string;
          line: number;
          project: string;
          exports: Array<{ __typename: "ExportDeclaration"; name: string } | null>;
          credential: { __typename: "Credential"; name: string; status: string } | null;
        } | null>;
      };
    }>;
  } | null;
};

export type DownloadRowsReportQueryVariables = Exact<{
  dimensions?: Array<string | null | undefined> | string | null | undefined;
  filters?: Types.RowsReportFiltersInput | null | undefined;
}>;

export type DownloadRowsReportQuery = {
  __typename: "Query";
  downloadRowsReport: {
    __typename: "RowsReport";
    forecast: number | null;
    contracted: number | null;
    rows: Array<{
      __typename: "RowsReportRow";
      project: string | null;
      month: number;
      year: number;
      purpose: string | null;
      totalRowCount: number;
      totalByteCount: number;
    }> | null;
  } | null;
};

export type SchemasQueryVariables = Exact<{ [key: string]: never }>;

export type SchemasQuery = {
  __typename: "Query";
  sbs_schemas: Array<{ __typename: "SbsSchema"; name: string } | null> | null;
};

export type SchemaByNameQueryVariables = Exact<{
  name: string;
}>;

export type SchemaByNameQuery = {
  __typename: "Query";
  sbs_schema: { __typename: "SbsSchema"; name: string; text: string } | null;
};

export type SourceBundlesQueryVariables = Exact<{
  importName?: string | null | undefined;
  project?: string | null | undefined;
}>;

export type SourceBundlesQuery = {
  __typename: "Query";
  source_bundles: {
    __typename: "SourceBundleConnection";
    edges: Array<{
      __typename: "SourceBundleEdge";
      node: {
        __typename: "SourceBundle";
        id: string;
        import_type: string;
        descriptor: any;
        tables: Array<{
          __typename: "SourceTable";
          id: string;
          name: string;
          descriptor: any;
          schema: any;
          changelist_id: string;
          project: string;
          line: number;
          exports: Array<{
            __typename: "ExportDeclaration";
            id: string;
            export_type: any;
            descriptor: any;
            name: string;
            schema: any;
            changelist_id: string;
            project: string;
            line: number;
          } | null>;
        } | null>;
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
  } | null;
};

export type SourceBundlesVolumeQueryVariables = Exact<{
  importName?: string | null | undefined;
  project?: string | null | undefined;
}>;

export type SourceBundlesVolumeQuery = {
  __typename: "Query";
  source_bundles: {
    __typename: "SourceBundleConnection";
    edges: Array<{
      __typename: "SourceBundleEdge";
      node: {
        __typename: "SourceBundle";
        id: string;
        import_type: string;
        descriptor: any;
        tables: Array<{
          __typename: "SourceTable";
          id: string;
          name: string;
          descriptor: any;
          parameters: any;
          changelist_id: string;
          project: string;
          line: number;
          exports: Array<{
            __typename: "ExportDeclaration";
            id: string;
            name: string;
            export_type: any;
            descriptor: any;
            changelist_id: string;
            project: string;
            line: number;
          } | null>;
          volume: {
            __typename: "Volume";
            production_rows: number;
            production_bytes: number;
            refill_rows: number;
            refill_bytes: number;
            backfill_rows: number;
            backfill_bytes: number;
            proof_rows: number;
            proof_bytes: number;
          };
        } | null>;
      };
    }>;
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
  } | null;
};

export type ExportStatusQueryVariables = Exact<{
  group_by?: string | null | undefined;
  name?: string | null | undefined;
  project?: string | null | undefined;
  lookback_days?: number | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type ExportStatusQuery = {
  __typename: "Query";
  export_status: {
    __typename: "ExportStatusConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "ExportStatusEdge";
      cursor: string;
      node: {
        __typename: "ExportStatus";
        name: string | null;
        project: string | null;
        status: string | null;
        credential: { __typename: "Credential"; name: string; status: string } | null;
        journal: Array<{
          __typename: "UploadJournal";
          date: string | null;
          running: number | null;
          completed: number | null;
          failed: number | null;
          total_rows: number | null;
          min_rows: number | null;
          max_rows: number | null;
          total_bytes: number | null;
          min_bytes: number | null;
          max_bytes: number | null;
        } | null> | null;
      };
    }>;
  } | null;
};

export type ImportStatusQueryVariables = Exact<{
  group_by?: string | null | undefined;
  name?: string | null | undefined;
  project?: string | null | undefined;
  lookback_days?: number | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type ImportStatusQuery = {
  __typename: "Query";
  import_status: {
    __typename: "ImportStatusConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "ImportStatusEdge";
      cursor: string;
      node: {
        __typename: "ImportStatus";
        name: string | null;
        status: string | null;
        project: string | null;
        credential: { __typename: "Credential"; name: string; status: string } | null;
        journal: Array<{
          __typename: "DownloadJournal";
          date: string | null;
          running: number;
          completed: number;
          failed: number;
          total_rows: number;
          min_rows: number;
          max_rows: number;
          total_bytes: number;
          min_bytes: number;
          max_bytes: number;
          dirty_rows: boolean;
        } | null> | null;
      };
    }>;
  } | null;
};

export type TestFlowsQueryVariables = Exact<{
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type TestFlowsQuery = {
  __typename: "Query";
  flows: {
    __typename: "FlowConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "FlowEdge";
      cursor: string;
      node: {
        __typename: "Flow";
        id: string;
        created: string;
        failed: boolean;
        phase: string;
        status: string;
        changelist: { __typename: "Changelist"; id: string; description: string };
        launched_by: { __typename: "User"; name: string; email: string };
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
        inputs: Array<{
          __typename: "FlowInput";
          name: string;
          source_table: {
            __typename: "SourceTable";
            id: string;
            name: string;
            project: string;
            bundle: {
              __typename: "SourceBundle";
              report_handle: any;
              recent_failed_probe: string | null;
              recent_successful_probe: string | null;
              next_probe: string | null;
            } | null;
          };
          download: {
            __typename: "DownloadBundle";
            id: string;
            created: string;
            started: string | null;
            finished: string | null;
            status: string;
            handle: any;
            progress: any;
            report_datetime: {
              __typename: "DateTimeHuman";
              short: string;
              long: string;
              long_utc: string;
              iso: string;
            } | null;
          } | null;
          download_part: {
            __typename: "DownloadPart";
            id: string;
            row_count: number | null;
            dirty_row_count: number | null;
            dirty_row_status: string | null;
            legacy_flow_source_id: string | null;
            download: {
              __typename: "DownloadBundle";
              id: string;
              handle: any;
              status: string;
              finished: string | null;
            };
          } | null;
        } | null>;
        processing: {
          __typename: "Processing";
          id: string;
          started: string | null;
          finished: string | null;
          status: string;
        } | null;
        outputs: Array<{
          __typename: "FlowOutput";
          id: string;
          name: string;
          project: string;
          handle: any;
          row_count: number | null;
          created: string | null;
          started: string | null;
          finished: string | null;
          status: string | null;
          report_datetime: {
            __typename: "DateTimeHuman";
            short: string;
            long: string;
            long_utc: string;
            iso: string;
          } | null;
          declaration: { __typename: "ExportDeclaration"; id: string };
        } | null>;
        events: Array<{
          __typename: "Event";
          id: string;
          created: string;
          message: string | null;
          severity: string | null;
          project_name: string | null;
          will_retry: boolean | null;
          comment: string | null;
          commented_on: string | null;
          download: { __typename: "DownloadBundle"; id: string } | null;
          flow: { __typename: "FlowSE"; id: string } | null;
          upload: { __typename: "Upload"; id: string } | null;
          commented_by: { __typename: "User"; name: string } | null;
        } | null>;
      };
    }>;
  } | null;
};

export type InputsFragmentFragment = {
  __typename: "DownloadPart";
  id: string;
  dirty_row_count: number | null;
  dirty_row_status: string | null;
  new_dirty_row_count: number | null;
  new_dirty_row_status: string | null;
  legacy_flow_source_id: string | null;
  row_count: number | null;
  source_table: { __typename: "SourceTable"; name: string; project: string };
  download: {
    __typename: "DownloadBundle";
    id: string;
    created: string;
    finished: string | null;
    handle: any;
    purpose: string;
    progress: any;
    started: string | null;
    status: string;
    report_datetime: { __typename: "DateTimeHuman"; short: string; long: string; long_utc: string; iso: string } | null;
    source_tables: Array<{ __typename: "SourceTable"; name: string; project: string } | null>;
  };
};

export type UploadDownloadsQueryVariables = Exact<{
  id: string;
}>;

export type UploadDownloadsQuery = {
  __typename: "Query";
  upload: {
    __typename: "Upload";
    inputs: Array<{
      __typename: "DownloadPart";
      id: string;
      dirty_row_count: number | null;
      dirty_row_status: string | null;
      new_dirty_row_count: number | null;
      new_dirty_row_status: string | null;
      legacy_flow_source_id: string | null;
      row_count: number | null;
      source_table: { __typename: "SourceTable"; name: string; project: string };
      download: {
        __typename: "DownloadBundle";
        id: string;
        created: string;
        finished: string | null;
        handle: any;
        purpose: string;
        progress: any;
        started: string | null;
        status: string;
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
        source_tables: Array<{ __typename: "SourceTable"; name: string; project: string } | null>;
      };
    } | null>;
  } | null;
};

export type AllUploadDownloadsQueryVariables = Exact<{
  id?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type AllUploadDownloadsQuery = {
  __typename: "Query";
  uploads: {
    __typename: "UploadConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "UploadEdge";
      cursor: string;
      node: {
        __typename: "Upload";
        id: string;
        name: string;
        project: string;
        handle: any;
        row_count: number | null;
        created: string;
        started: string | null;
        finished: string | null;
        status: string;
        destination: string | null;
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
        inputs: Array<{
          __typename: "DownloadPart";
          id: string;
          dirty_row_count: number | null;
          dirty_row_status: string | null;
          new_dirty_row_count: number | null;
          new_dirty_row_status: string | null;
          legacy_flow_source_id: string | null;
          row_count: number | null;
          source_table: { __typename: "SourceTable"; name: string; project: string };
          download: {
            __typename: "DownloadBundle";
            id: string;
            created: string;
            finished: string | null;
            handle: any;
            purpose: string;
            progress: any;
            started: string | null;
            status: string;
            report_datetime: {
              __typename: "DateTimeHuman";
              short: string;
              long: string;
              long_utc: string;
              iso: string;
            } | null;
            source_tables: Array<{ __typename: "SourceTable"; name: string; project: string } | null>;
          };
        } | null>;
      };
    }>;
  } | null;
};

export type UploadForDownloadsQueryVariables = Exact<{
  id?: string | null | undefined;
  download_part_id?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
  downloadPartIds?: Array<string | null | undefined> | string | null | undefined;
}>;

export type UploadForDownloadsQuery = {
  __typename: "Query";
  uploads: {
    __typename: "UploadConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "UploadEdge";
      cursor: string;
      node: {
        __typename: "Upload";
        id: string;
        name: string;
        project: string;
        handle: any;
        row_count: number | null;
        created: string;
        purpose: string | null;
        started: string | null;
        finished: string | null;
        status: string;
        destination: string | null;
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
      };
    }>;
  } | null;
};

export type UploadsQueryVariables = Exact<{
  name?: string | null | undefined;
  names?: Array<string | null | undefined> | string | null | undefined;
  project?: string | null | undefined;
  projects?: Array<string | null | undefined> | string | null | undefined;
  purpose?: string | null | undefined;
  report_datetime_after?: string | null | undefined;
  report_datetime_before?: string | null | undefined;
  search?: string | null | undefined;
  status?: string | null | undefined;
  uploaded_after?: string | null | undefined;
  uploaded_before?: string | null | undefined;
  destination?: string | null | undefined;
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
  sortBy?: Types.DataGridSortableColumns | null | undefined;
  sortDirection?: Types.SortDirection | null | undefined;
}>;

export type UploadsQuery = {
  __typename: "Query";
  uploads: {
    __typename: "UploadConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "UploadEdge";
      cursor: string;
      node: {
        __typename: "Upload";
        id: string;
        name: string;
        project: string;
        purpose: string | null;
        handle: any;
        row_count: number | null;
        created: string;
        started: string | null;
        finished: string | null;
        status: string;
        destination: string | null;
        report_datetime: {
          __typename: "DateTimeHuman";
          short: string;
          long: string;
          long_utc: string;
          iso: string;
        } | null;
      };
    }>;
  } | null;
};

export type UsersListQueryVariables = Exact<{
  first?: number | null | undefined;
  after?: string | null | undefined;
  last?: number | null | undefined;
  before?: string | null | undefined;
}>;

export type UsersListQuery = {
  __typename: "Query";
  users: {
    __typename: "UserConnection";
    pageInfo: {
      __typename: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      __typename: "UserEdge";
      node: { __typename: "User"; id: string; name: string; email: string; globalRoles: Array<string> | null };
    }>;
  } | null;
};

export type UserDetailsQueryVariables = Exact<{
  userId: string;
}>;

export type UserDetailsQuery = {
  __typename: "Query";
  userV2: {
    __typename: "UserDetailV2";
    id: string;
    email: string;
    name: string;
    globalRoles: Array<string> | null;
    accounts: Array<{ __typename: "UserAccounts"; id: string; urlName: string; name: string; roles: Array<string> }>;
    identities: Array<{
      __typename: "Auth0Identity";
      id: string;
      name: string;
      email: string;
      connectionType: string;
      emailVerified: boolean;
      blocked: boolean;
    }>;
  } | null;
};

export type AccountsForLoggedUserQueryVariables = Exact<{ [key: string]: never }>;

export type AccountsForLoggedUserQuery = {
  __typename: "Query";
  meV2: {
    __typename: "Me";
    accounts: Array<{
      __typename: "UserAccounts";
      name: string;
      urlName: string;
      show_download_summary: boolean | null;
    }>;
  } | null;
};

export const FlowsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FlowsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Flow" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "launched_by" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created" } },
          { kind: "Field", name: { kind: "Name", value: "failed" } },
          { kind: "Field", name: { kind: "Name", value: "phase" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "report_datetime" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "short" } },
                { kind: "Field", name: { kind: "Name", value: "long" } },
                { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                { kind: "Field", name: { kind: "Name", value: "iso" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inputs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "source_table" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bundle" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "report_handle" } },
                            { kind: "Field", name: { kind: "Name", value: "recent_failed_probe" } },
                            { kind: "Field", name: { kind: "Name", value: "recent_successful_probe" } },
                            { kind: "Field", name: { kind: "Name", value: "next_probe" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "download" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "report_datetime" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "short" } },
                            { kind: "Field", name: { kind: "Name", value: "long" } },
                            { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                            { kind: "Field", name: { kind: "Name", value: "iso" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "created" } },
                      { kind: "Field", name: { kind: "Name", value: "started" } },
                      { kind: "Field", name: { kind: "Name", value: "finished" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "handle" } },
                      { kind: "Field", name: { kind: "Name", value: "progress" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "download_part" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "row_count" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
                      { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "download" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "processing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "outputs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "project" } },
                { kind: "Field", name: { kind: "Name", value: "handle" } },
                { kind: "Field", name: { kind: "Name", value: "row_count" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report_datetime" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "short" } },
                      { kind: "Field", name: { kind: "Name", value: "long" } },
                      { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                      { kind: "Field", name: { kind: "Name", value: "iso" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                { kind: "Field", name: { kind: "Name", value: "project_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "download" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flow" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "will_retry" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "commented_on" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commented_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlowsFragmentFragment, unknown>;
export const InputsFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InputsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DownloadPart" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
          { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
          { kind: "Field", name: { kind: "Name", value: "new_dirty_row_count" } },
          { kind: "Field", name: { kind: "Name", value: "new_dirty_row_status" } },
          { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
          { kind: "Field", name: { kind: "Name", value: "row_count" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "source_table" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "project" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "download" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "handle" } },
                { kind: "Field", name: { kind: "Name", value: "purpose" } },
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report_datetime" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "short" } },
                      { kind: "Field", name: { kind: "Name", value: "long" } },
                      { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                      { kind: "Field", name: { kind: "Name", value: "iso" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "source_tables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InputsFragmentFragment, unknown>;
export const SaveDownloadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_download" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_download" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "download" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveDownloadMutation, SaveDownloadMutationVariables>;
export const SaveUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_upload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_upload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "upload" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveUploadMutation, SaveUploadMutationVariables>;
export const SaveAccountV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveAccountV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newUrlName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "setDefaultDeadline" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "removeDefaultDeadline" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "setSummaryTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "removeSummaryTime" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "setSummaryRecipients" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "clearSummaryRecipients" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "showDownloadSummary" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contractedRowCount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "BigInt" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveAccountV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "urlName" },
                value: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "account" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "Variable", name: { kind: "Name", value: "name" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "urlName" },
                      value: { kind: "Variable", name: { kind: "Name", value: "newUrlName" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "setDefaultDeadline" },
                      value: { kind: "Variable", name: { kind: "Name", value: "setDefaultDeadline" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "removeDefaultDeadline" },
                      value: { kind: "Variable", name: { kind: "Name", value: "removeDefaultDeadline" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "setSummaryTime" },
                      value: { kind: "Variable", name: { kind: "Name", value: "setSummaryTime" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "removeSummaryTime" },
                      value: { kind: "Variable", name: { kind: "Name", value: "removeSummaryTime" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "setSummaryRecipients" },
                      value: { kind: "Variable", name: { kind: "Name", value: "setSummaryRecipients" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "clearSummaryRecipients" },
                      value: { kind: "Variable", name: { kind: "Name", value: "clearSummaryRecipients" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "showDownloadSummary" },
                      value: { kind: "Variable", name: { kind: "Name", value: "showDownloadSummary" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contractedRowCount" },
                      value: { kind: "Variable", name: { kind: "Name", value: "contractedRowCount" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ResultOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveAccountErrors" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "errors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConflictingNameError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConflictingUrlNameError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveAccountV2Mutation, SaveAccountV2MutationVariables>;
export const DeactivateAccountV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deactivateAccountV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deactivateAccountV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "urlName" },
                value: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeactivateAccountV2Mutation, DeactivateAccountV2MutationVariables>;
export const ResetAuth0PasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resetAuth0Password" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resetAuth0Password" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetAuth0PasswordMutation, ResetAuth0PasswordMutationVariables>;
export const SetAuth0UserBlockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "setAuth0UserBlock" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "blocked" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setAuth0UserBlock" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "blocked" },
                value: { kind: "Variable", name: { kind: "Name", value: "blocked" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetAuth0UserBlockMutation, SetAuth0UserBlockMutationVariables>;
export const BackfillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "backfill" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "since" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "until" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "backfill_source_bundle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "since" },
                value: { kind: "Variable", name: { kind: "Name", value: "since" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "until" },
                value: { kind: "Variable", name: { kind: "Name", value: "until" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ok" } },
                { kind: "Field", name: { kind: "Name", value: "handles" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BackfillMutation, BackfillMutationVariables>;
export const LaunchBackfillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "launch_backfill" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "upload_names" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "title" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "start_datetime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "end_datetime" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "launch_backfill" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "backfill" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "upload_names" },
                      value: { kind: "Variable", name: { kind: "Name", value: "upload_names" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "title" },
                      value: { kind: "Variable", name: { kind: "Name", value: "title" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "description" },
                      value: { kind: "Variable", name: { kind: "Name", value: "description" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "start_datetime" },
                      value: { kind: "Variable", name: { kind: "Name", value: "start_datetime" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "end_datetime" },
                      value: { kind: "Variable", name: { kind: "Name", value: "end_datetime" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Backfill" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_by" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelled_by" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "start_datetime" } },
                      { kind: "Field", name: { kind: "Name", value: "end_datetime" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changelist" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subgraph" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "upload_names" } },
                      { kind: "Field", name: { kind: "Name", value: "download_names" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "total_pipelines" } },
                      { kind: "Field", name: { kind: "Name", value: "succeeded_pipelines" } },
                      { kind: "Field", name: { kind: "Name", value: "failed_pipelines" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ConflictingBackfillsError" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conflicting_backfills" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LaunchBackfillMutation, LaunchBackfillMutationVariables>;
export const SaveBackfillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_backfill" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "title" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_backfill" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "backfill_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "backfill" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "title" },
                      value: { kind: "Variable", name: { kind: "Name", value: "title" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "description" },
                      value: { kind: "Variable", name: { kind: "Name", value: "description" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveBackfillMutation, SaveBackfillMutationVariables>;
export const SaveChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_changelist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "changelist_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "action" },
                value: { kind: "Variable", name: { kind: "Name", value: "action" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveChangelistOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changelist" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "created_on" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_on" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveChangelistMutation, SaveChangelistMutationVariables>;
export const BranchChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "branch_changelist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "description" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "branch_changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "description" },
                value: { kind: "Variable", name: { kind: "Name", value: "description" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "changelist_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changelist" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "created_on" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_on" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BranchChangelistMutation, BranchChangelistMutationVariables>;
export const RenameChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "rename_changelist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "changelist" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SaveChangelistInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "changelist_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "changelist" },
                value: { kind: "Variable", name: { kind: "Name", value: "changelist" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveChangelistOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changelist" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "description" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenameChangelistMutation, RenameChangelistMutationVariables>;
export const UpdateChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "update_changelist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "changelist" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SaveChangelistInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "action" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "fetch_new_downloads" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "test_exports" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "force_publish" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "changelist_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "changelist_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "changelist" },
                value: { kind: "Variable", name: { kind: "Name", value: "changelist" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "action" },
                value: { kind: "Variable", name: { kind: "Name", value: "action" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "fetch_new_downloads" },
                value: { kind: "Variable", name: { kind: "Name", value: "fetch_new_downloads" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "test_exports" },
                value: { kind: "Variable", name: { kind: "Name", value: "test_exports" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "force_publish" },
                value: { kind: "Variable", name: { kind: "Name", value: "force_publish" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveChangelistOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changelist" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "files" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "path" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "compilation_result" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "declarations" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "connector_type" } },
                                        { kind: "Field", name: { kind: "Name", value: "path" } },
                                        { kind: "Field", name: { kind: "Name", value: "line" } },
                                        { kind: "Field", name: { kind: "Name", value: "column" } },
                                        { kind: "Field", name: { kind: "Name", value: "declaration_type" } },
                                        { kind: "Field", name: { kind: "Name", value: "test" } },
                                        { kind: "Field", name: { kind: "Name", value: "key_name" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "messages" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                        { kind: "Field", name: { kind: "Name", value: "path" } },
                                        { kind: "Field", name: { kind: "Name", value: "line" } },
                                        { kind: "Field", name: { kind: "Name", value: "column" } },
                                        { kind: "Field", name: { kind: "Name", value: "message" } },
                                        { kind: "Field", name: { kind: "Name", value: "startLine" } },
                                        { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                                        { kind: "Field", name: { kind: "Name", value: "endLine" } },
                                        { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "action" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NeedsMergeError" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChangelistMutation, UpdateChangelistMutationVariables>;
export const SaveCredentialDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_credential" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "new_name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "credential_type" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "properties" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GenericScalar" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "replace_properties" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_credential" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "replace_properties" },
                value: { kind: "Variable", name: { kind: "Name", value: "replace_properties" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "credential" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "Variable", name: { kind: "Name", value: "new_name" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "credential_type" },
                      value: { kind: "Variable", name: { kind: "Name", value: "credential_type" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "properties" },
                      value: { kind: "Variable", name: { kind: "Name", value: "properties" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveCredentialOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ok" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "credential" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "InvalidCredential" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ValidationErrors" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "errors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "typeId" } },
                            { kind: "Field", name: { kind: "Name", value: "properties" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveCredentialMutation, SaveCredentialMutationVariables>;
export const SaveIntegrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_integration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "integration_type" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "authorization" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GenericScalar" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "configuration" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "GenericScalar" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "IntegrationFilterInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_integration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "integration" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "integration_type" },
                      value: { kind: "Variable", name: { kind: "Name", value: "integration_type" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "authorization" },
                      value: { kind: "Variable", name: { kind: "Name", value: "authorization" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "configuration" },
                      value: { kind: "Variable", name: { kind: "Name", value: "configuration" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ok" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "integration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "integration_type" } },
                      { kind: "Field", name: { kind: "Name", value: "public_authorization" } },
                      { kind: "Field", name: { kind: "Name", value: "configuration" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "filters" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "production" } },
                            { kind: "Field", name: { kind: "Name", value: "backfills" } },
                            { kind: "Field", name: { kind: "Name", value: "proofs" } },
                            { kind: "Field", name: { kind: "Name", value: "lateUploads" } },
                            { kind: "Field", name: { kind: "Name", value: "beta" } },
                            { kind: "Field", name: { kind: "Name", value: "configuration" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "assistance" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveIntegrationMutation, SaveIntegrationMutationVariables>;
export const RemoveIntegrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "remove_integration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "remove_integration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveIntegrationMutation, RemoveIntegrationMutationVariables>;
export const SaveSourceBundleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_source_bundle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_source_bundle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bundle" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveSourceBundleMutation, SaveSourceBundleMutationVariables>;
export const SaveExportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "save_export" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_export" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "export" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveExportMutation, SaveExportMutationVariables>;
export const ArchiveTestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "archive_test" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_flow" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "update" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "archived" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArchiveTestMutation, ArchiveTestMutationVariables>;
export const SaveUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "urlNames" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "roles" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userEmail" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userPassword" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "blocked" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saveUserV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "urlNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "urlNames" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roles" },
                value: { kind: "Variable", name: { kind: "Name", value: "roles" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "user" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email" },
                      value: { kind: "Variable", name: { kind: "Name", value: "userEmail" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "Variable", name: { kind: "Name", value: "userName" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "password" },
                      value: { kind: "Variable", name: { kind: "Name", value: "userPassword" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "blocked" },
                      value: { kind: "Variable", name: { kind: "Name", value: "blocked" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveUserSuccessMutationResult" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ok" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "globalRoles" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accounts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "urlName" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "roles" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveUserErrors" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "errors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "ConflictingEmailError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "InsecurePasswordError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "message" } },
                                  { kind: "Field", name: { kind: "Name", value: "passwordErrors" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveUserMutation, SaveUserMutationVariables>;
export const RemoveUserV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "removeUserV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeUserV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "urlName" },
                value: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ResultOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RemoveUserV2Errors" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "errors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AttachedToMoreAccountsError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveUserV2Mutation, RemoveUserV2MutationVariables>;
export const AccountsV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "accountsV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accountsV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "urlName" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountsV2Query, AccountsV2QueryVariables>;
export const AccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "account" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "urlName" },
                value: { kind: "Variable", name: { kind: "Name", value: "urlName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "urlName" } },
                { kind: "Field", name: { kind: "Name", value: "defaultDeadline" } },
                { kind: "Field", name: { kind: "Name", value: "dailySummaryTime" } },
                { kind: "Field", name: { kind: "Name", value: "dailySummaryRecipients" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "contractedRowCount" } },
                { kind: "Field", name: { kind: "Name", value: "showDownloadSummary" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountQuery, AccountQueryVariables>;
export const VerifyEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "verifyEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: { kind: "Variable", name: { kind: "Name", value: "email" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "auth0Name" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "useIdP" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyEmailQuery, VerifyEmailQueryVariables>;
export const BackfillsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "backfills" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "created_datetime_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "created_datetime_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateTime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "backfills" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: { kind: "Variable", name: { kind: "Name", value: "ids" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "created_datetime_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "created_datetime_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "created_datetime_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "created_datetime_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "upload_names" } },
                            { kind: "Field", name: { kind: "Name", value: "download_names" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_on" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelled_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "cancelled_on" } },
                            { kind: "Field", name: { kind: "Name", value: "start_datetime" } },
                            { kind: "Field", name: { kind: "Name", value: "end_datetime" } },
                            { kind: "Field", name: { kind: "Name", value: "total_pipelines" } },
                            { kind: "Field", name: { kind: "Name", value: "succeeded_pipelines" } },
                            { kind: "Field", name: { kind: "Name", value: "failed_pipelines" } },
                            { kind: "Field", name: { kind: "Name", value: "cancelled_pipelines" } },
                            { kind: "Field", name: { kind: "Name", value: "hasDirtyRows" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BackfillsQuery, BackfillsQueryVariables>;
export const BackfillDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "backfill_detail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "backfill" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "start_datetime" } },
                { kind: "Field", name: { kind: "Name", value: "end_datetime" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled_pipelines" } },
                { kind: "Field", name: { kind: "Name", value: "total_pipelines" } },
                { kind: "Field", name: { kind: "Name", value: "succeeded_pipelines" } },
                { kind: "Field", name: { kind: "Name", value: "failed_pipelines" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "created_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelled_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "download_names" } },
                { kind: "Field", name: { kind: "Name", value: "upload_names" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subgraph" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "download_declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "bundle_name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exports" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "upload_declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "created_on" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled_on" } },
                { kind: "Field", name: { kind: "Name", value: "hasDirtyRows" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BackfillDetailQuery, BackfillDetailQueryVariables>;
export const BackfillFlowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "backfill_flows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "phase" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortDirection" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flows" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "backfill_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "phase" },
                value: { kind: "Variable", name: { kind: "Name", value: "phase" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortDirection" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "changelist" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "description" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "launched_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "failed" } },
                            { kind: "Field", name: { kind: "Name", value: "phase" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "report_datetime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "short" } },
                                  { kind: "Field", name: { kind: "Name", value: "long" } },
                                  { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                  { kind: "Field", name: { kind: "Name", value: "iso" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inputs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source_table" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "project" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "bundle" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "report_handle" } },
                                              { kind: "Field", name: { kind: "Name", value: "recent_failed_probe" } },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "recent_successful_probe" },
                                              },
                                              { kind: "Field", name: { kind: "Name", value: "next_probe" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "download" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "report_datetime" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "short" } },
                                              { kind: "Field", name: { kind: "Name", value: "long" } },
                                              { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                              { kind: "Field", name: { kind: "Name", value: "iso" } },
                                            ],
                                          },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "created" } },
                                        { kind: "Field", name: { kind: "Name", value: "started" } },
                                        { kind: "Field", name: { kind: "Name", value: "finished" } },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                        { kind: "Field", name: { kind: "Name", value: "handle" } },
                                        { kind: "Field", name: { kind: "Name", value: "progress" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "download_part" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "row_count" } },
                                        { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
                                        { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
                                        { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "download" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              { kind: "Field", name: { kind: "Name", value: "id" } },
                                              { kind: "Field", name: { kind: "Name", value: "handle" } },
                                              { kind: "Field", name: { kind: "Name", value: "status" } },
                                              { kind: "Field", name: { kind: "Name", value: "finished" } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "processing" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "started" } },
                                  { kind: "Field", name: { kind: "Name", value: "finished" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "outputs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                  { kind: "Field", name: { kind: "Name", value: "handle" } },
                                  { kind: "Field", name: { kind: "Name", value: "row_count" } },
                                  { kind: "Field", name: { kind: "Name", value: "created" } },
                                  { kind: "Field", name: { kind: "Name", value: "started" } },
                                  { kind: "Field", name: { kind: "Name", value: "finished" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "report_datetime" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "short" } },
                                        { kind: "Field", name: { kind: "Name", value: "long" } },
                                        { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                        { kind: "Field", name: { kind: "Name", value: "iso" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "declaration" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BackfillFlowsQuery, BackfillFlowsQueryVariables>;
export const BackfillMessagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "backfill_messages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "created_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "created_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "severity" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "backfill_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "backfill_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "created_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "created_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "created_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "created_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "severity" },
                value: { kind: "Variable", name: { kind: "Name", value: "severity" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "project_name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "download" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flow" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "upload" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "will_retry" } },
                            { kind: "Field", name: { kind: "Name", value: "comment" } },
                            { kind: "Field", name: { kind: "Name", value: "commented_on" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commented_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BackfillMessagesQuery, BackfillMessagesQueryVariables>;
export const PublishedChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "published_changelist" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "published_on" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishedChangelistQuery, PublishedChangelistQueryVariables>;
export const QueryChangelistFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "query_changelist_file" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "opened_paths" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "opened_files" },
                  name: { kind: "Name", value: "files" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "paths" },
                      value: { kind: "Variable", name: { kind: "Name", value: "opened_paths" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryChangelistFileQuery, QueryChangelistFileQueryVariables>;
export const DiffViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "diff_view" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draft_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "currentDraft" },
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "draft_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "all_files" },
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compilation_result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "connector_type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "declaration_type" } },
                            { kind: "Field", name: { kind: "Name", value: "test" } },
                            { kind: "Field", name: { kind: "Name", value: "key_name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "messages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "startLine" } },
                            { kind: "Field", name: { kind: "Name", value: "endLine" } },
                            { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                            { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flow_summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "purpose" } },
                      { kind: "Field", name: { kind: "Name", value: "unfinished" } },
                      { kind: "Field", name: { kind: "Name", value: "succeeded" } },
                      { kind: "Field", name: { kind: "Name", value: "failed" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_rows_all" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_rows_some" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "publishedDraft" },
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "all_files" },
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiffViewQuery, DiffViewQueryVariables>;
export const DiffOpenFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "diff_open_files" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draft_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "published_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draft_opened_paths" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "published_opened_paths" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "currentDraft" },
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "draft_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "opened_files" },
                  name: { kind: "Name", value: "files" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "paths" },
                      value: { kind: "Variable", name: { kind: "Name", value: "draft_opened_paths" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "publishedDraft" },
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "published_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "opened_files" },
                  name: { kind: "Name", value: "files" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "paths" },
                      value: { kind: "Variable", name: { kind: "Name", value: "published_opened_paths" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DiffOpenFilesQuery, DiffOpenFilesQueryVariables>;
export const PublishedDiffOpenFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "published_diff_open_files" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draft_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "draft_opened_paths" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "published_opened_paths" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "currentDraft" },
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "draft_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "opened_files" },
                  name: { kind: "Name", value: "files" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "paths" },
                      value: { kind: "Variable", name: { kind: "Name", value: "draft_opened_paths" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "publishedDraft" },
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "opened_files" },
                  name: { kind: "Name", value: "files" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "paths" },
                      value: { kind: "Variable", name: { kind: "Name", value: "published_opened_paths" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishedDiffOpenFilesQuery, PublishedDiffOpenFilesQueryVariables>;
export const ChangelistDiffFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "changelist_diff_files" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "original_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "modified_id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist_diff" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "original_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "original_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "modified_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "modified_id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "unchanged_files" } },
                { kind: "Field", name: { kind: "Name", value: "modified_files" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_files" } },
                { kind: "Field", name: { kind: "Name", value: "created_files" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangelistDiffFilesQuery, ChangelistDiffFilesQueryVariables>;
export const QueryJustChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "query_just_changelist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "all_files" },
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compilation_result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "connector_type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "declaration_type" } },
                            { kind: "Field", name: { kind: "Name", value: "test" } },
                            { kind: "Field", name: { kind: "Name", value: "key_name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "messages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "startLine" } },
                            { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                            { kind: "Field", name: { kind: "Name", value: "endLine" } },
                            { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flow_summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "purpose" } },
                      { kind: "Field", name: { kind: "Name", value: "unfinished" } },
                      { kind: "Field", name: { kind: "Name", value: "succeeded" } },
                      { kind: "Field", name: { kind: "Name", value: "failed" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_rows_all" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_rows_some" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryJustChangelistQuery, QueryJustChangelistQueryVariables>;
export const ChangelistOutdatedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "changelist_outdated" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "needs_merge" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangelistOutdatedQuery, ChangelistOutdatedQueryVariables>;
export const CredentialDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "credential" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "credential" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "credential_type" } },
                { kind: "Field", name: { kind: "Name", value: "properties" } },
                { kind: "Field", name: { kind: "Name", value: "properties_exist" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CredentialQuery, CredentialQueryVariables>;
export const CredentialOauthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "credential_oauth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "credential_type" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "credential" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "credential_type" },
                value: { kind: "Variable", name: { kind: "Name", value: "credential_type" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "exist" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CredentialOauthQuery, CredentialOauthQueryVariables>;
export const CredentialsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "credentials" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "credentialTypes" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "statusFilters" } },
          type: {
            kind: "ListType",
            type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "credentials" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "credentialTypes" },
                value: { kind: "Variable", name: { kind: "Name", value: "credentialTypes" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statusFilters" },
                value: { kind: "Variable", name: { kind: "Name", value: "statusFilters" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortDirection" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "credential_type" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "properties" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CredentialsQuery, CredentialsQueryVariables>;
export const GetSuspendedCredentialCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSuspendedCredentialCount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "getSuspendedCredentialCount" } }],
      },
    },
  ],
} as unknown as DocumentNode<GetSuspendedCredentialCountQuery, GetSuspendedCredentialCountQueryVariables>;
export const GetDataFlowDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDataFlow" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDataFlow" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "scriptbookId" } },
                { kind: "Field", name: { kind: "Name", value: "scriptbookDescription" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "steps" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "declarationName" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                      { kind: "Field", name: { kind: "Name", value: "line" } },
                      { kind: "Field", name: { kind: "Name", value: "sourceTables" } },
                      { kind: "Field", name: { kind: "Name", value: "destTables" } },
                      { kind: "Field", name: { kind: "Name", value: "inputs" } },
                      { kind: "Field", name: { kind: "Name", value: "outputs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDataFlowQuery, GetDataFlowQueryVariables>;
export const DownloadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "download" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "download" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "handle" } },
                { kind: "Field", name: { kind: "Name", value: "purpose" } },
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report_datetime" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "short" } },
                      { kind: "Field", name: { kind: "Name", value: "long" } },
                      { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                      { kind: "Field", name: { kind: "Name", value: "iso" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "source_tables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
                      { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
                      { kind: "Field", name: { kind: "Name", value: "row_count" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source_table" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "hasConnectedUploadDeclarations" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadQuery, DownloadQueryVariables>;
export const FlowDownloadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "flow_downloads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flow_downloads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "purpose" } },
                            { kind: "Field", name: { kind: "Name", value: "progress" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "report_datetime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "short" } },
                                  { kind: "Field", name: { kind: "Name", value: "long" } },
                                  { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                  { kind: "Field", name: { kind: "Name", value: "iso" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source_tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "started" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "parts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
                                  { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "row_count" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source_table" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "project" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlowDownloadsQuery, FlowDownloadsQueryVariables>;
export const DownloadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "downloads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dirty" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dirtyEqualsNewDirty" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newDirtyGreaterThanDirty" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "downloaded_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "downloaded_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "names" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundle_name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bundleNames" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "project" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projects" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "purpose" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DataGridSortableColumns" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortDirection" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dirty" },
                value: { kind: "Variable", name: { kind: "Name", value: "dirty" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dirtyEqualsNewDirty" },
                value: { kind: "Variable", name: { kind: "Name", value: "dirtyEqualsNewDirty" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newDirtyGreaterThanDirty" },
                value: { kind: "Variable", name: { kind: "Name", value: "newDirtyGreaterThanDirty" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "downloaded_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "downloaded_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "downloaded_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "downloaded_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "names" },
                value: { kind: "Variable", name: { kind: "Name", value: "names" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bundle_name" },
                value: { kind: "Variable", name: { kind: "Name", value: "bundle_name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bundleNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "bundleNames" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: { kind: "Variable", name: { kind: "Name", value: "project" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projects" },
                value: { kind: "Variable", name: { kind: "Name", value: "projects" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "purpose" },
                value: { kind: "Variable", name: { kind: "Name", value: "purpose" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortDirection" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "purpose" } },
                            { kind: "Field", name: { kind: "Name", value: "progress" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "report_datetime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "short" } },
                                  { kind: "Field", name: { kind: "Name", value: "long" } },
                                  { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                  { kind: "Field", name: { kind: "Name", value: "iso" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source_tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "started" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "parts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
                                  { kind: "Field", name: { kind: "Name", value: "new_dirty_row_count" } },
                                  { kind: "Field", name: { kind: "Name", value: "new_dirty_row_status" } },
                                  { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "row_count" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source_table" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "project" } },
                                      ],
                                    },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "hasConnectedUploadDeclarations" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadsQuery, DownloadsQueryVariables>;
export const DraftsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "drafts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "archived" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "drafts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "archived" },
                value: { kind: "Variable", name: { kind: "Name", value: "archived" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "created_on" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_on" } },
                            { kind: "Field", name: { kind: "Name", value: "published_on" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "archived" } },
                            { kind: "Field", name: { kind: "Name", value: "needs_merge" } },
                            { kind: "Field", name: { kind: "Name", value: "branched_from" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updated_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "published_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flow_summary" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "purpose" } },
                                  { kind: "Field", name: { kind: "Name", value: "unfinished" } },
                                  { kind: "Field", name: { kind: "Name", value: "succeeded" } },
                                  { kind: "Field", name: { kind: "Name", value: "failed" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_rows_all" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_rows_some" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DraftsQuery, DraftsQueryVariables>;
export const PublishedDraftDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "published_draft" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "created_on" } },
                { kind: "Field", name: { kind: "Name", value: "updated_on" } },
                { kind: "Field", name: { kind: "Name", value: "published_on" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "created_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updated_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishedDraftQuery, PublishedDraftQueryVariables>;
export const QueryFullEditorPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "query_full_editor_page" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "credentials" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "credential_type" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "archived" } },
                { kind: "Field", name: { kind: "Name", value: "needs_merge" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "all_files" },
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compilation_result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "connector_type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "declaration_type" } },
                            { kind: "Field", name: { kind: "Name", value: "test" } },
                            { kind: "Field", name: { kind: "Name", value: "key_name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "messages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "startLine" } },
                            { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                            { kind: "Field", name: { kind: "Name", value: "endLine" } },
                            { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flow_summary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "purpose" } },
                      { kind: "Field", name: { kind: "Name", value: "unfinished" } },
                      { kind: "Field", name: { kind: "Name", value: "succeeded" } },
                      { kind: "Field", name: { kind: "Name", value: "failed" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_rows_all" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_rows_some" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sbs_schemas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryFullEditorPageQuery, QueryFullEditorPageQueryVariables>;
export const QueryCompilationResultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "query_compilation_result" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "needs_merge" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compilation_result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "connector_type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "declaration_type" } },
                            { kind: "Field", name: { kind: "Name", value: "test" } },
                            { kind: "Field", name: { kind: "Name", value: "key_name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "messages" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "column" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "startLine" } },
                            { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                            { kind: "Field", name: { kind: "Name", value: "endLine" } },
                            { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryCompilationResultQuery, QueryCompilationResultQueryVariables>;
export const EmailRecipientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "emailRecipients" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rules" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "senderGlob" } },
                      { kind: "Field", name: { kind: "Name", value: "subjectGlob" } },
                      { kind: "Field", name: { kind: "Name", value: "senderRegex" } },
                      { kind: "Field", name: { kind: "Name", value: "subjectRegex" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "matchOrder" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmailRecipientsQuery, EmailRecipientsQueryVariables>;
export const SaveEmailMatchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveEmailMatch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipient" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "deactivate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "rule" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "RuleInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_emailmatch" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipient" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipient" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deactivate" },
                value: { kind: "Variable", name: { kind: "Name", value: "deactivate" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "rule" },
                value: { kind: "Variable", name: { kind: "Name", value: "rule" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveEmailMatchOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rules" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "senderGlob" } },
                            { kind: "Field", name: { kind: "Name", value: "subjectGlob" } },
                            { kind: "Field", name: { kind: "Name", value: "senderRegex" } },
                            { kind: "Field", name: { kind: "Name", value: "subjectRegex" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "matchOrder" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "InvalidRegexError" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "InvalidPathError" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveEmailMatchMutation, SaveEmailMatchMutationVariables>;
export const SaveEmailRecipientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveEmailRecipient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "recipient" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "newRecipient" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "deactivate" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_emailrecipient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "recipient" },
                value: { kind: "Variable", name: { kind: "Name", value: "recipient" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newRecipient" },
                value: { kind: "Variable", name: { kind: "Name", value: "newRecipient" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deactivate" },
                value: { kind: "Variable", name: { kind: "Name", value: "deactivate" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SaveEmailRecipientOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "newEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "oldEmail" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RecipientAlreadyExistsError" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveEmailRecipientMutation, SaveEmailRecipientMutationVariables>;
export const EventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "events" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "severity" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "severities" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "created_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "created_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "withComments" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectNames" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "downloadNames" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uploadNames" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "severity" },
                value: { kind: "Variable", name: { kind: "Name", value: "severity" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "severities" },
                value: { kind: "Variable", name: { kind: "Name", value: "severities" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "created_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "created_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "created_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "created_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "withComments" },
                value: { kind: "Variable", name: { kind: "Name", value: "withComments" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectNames" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "downloadNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "downloadNames" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadNames" },
                value: { kind: "Variable", name: { kind: "Name", value: "uploadNames" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "report_datetime" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "severity" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "project_name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "download" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flow" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "upload" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "will_retry" } },
                            { kind: "Field", name: { kind: "Name", value: "comment" } },
                            { kind: "Field", name: { kind: "Name", value: "commented_on" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "commented_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "download_declaration" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "upload_declaration" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "retry_count" } },
                            { kind: "Field", name: { kind: "Name", value: "retry_limit" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EventsQuery, EventsQueryVariables>;
export const UpdateCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "update_comment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "comment" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "save_event" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "event" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "comment" },
                      value: { kind: "Variable", name: { kind: "Name", value: "comment" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ok" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "comment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const HistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "history" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "history" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "created_on" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_on" } },
                            { kind: "Field", name: { kind: "Name", value: "published_on" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "archived" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "published_by" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HistoryQuery, HistoryQueryVariables>;
export const HomepageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Homepage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "refresh" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "homepage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "refresh" },
                value: { kind: "Variable", name: { kind: "Name", value: "refresh" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Homepage" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "downloads" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "dependencyStatus" } },
                            { kind: "Field", name: { kind: "Name", value: "artifactStatus" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "event" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "created" } },
                                  { kind: "Field", name: { kind: "Name", value: "eventId" } },
                                  { kind: "Field", name: { kind: "Name", value: "message" } },
                                  { kind: "Field", name: { kind: "Name", value: "purpose" } },
                                  { kind: "Field", name: { kind: "Name", value: "qualname" } },
                                  { kind: "Field", name: { kind: "Name", value: "severity" } },
                                  { kind: "Field", name: { kind: "Name", value: "willRetry" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pos" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                                  { kind: "Field", name: { kind: "Name", value: "endLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "path" } },
                                  { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                                  { kind: "Field", name: { kind: "Name", value: "startLine" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sparkline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "running" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "refreshedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "sparklineFirstDate" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "uploads" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "dependencyStatus" } },
                            { kind: "Field", name: { kind: "Name", value: "artifactStatus" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "event" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "created" } },
                                  { kind: "Field", name: { kind: "Name", value: "eventId" } },
                                  { kind: "Field", name: { kind: "Name", value: "message" } },
                                  { kind: "Field", name: { kind: "Name", value: "purpose" } },
                                  { kind: "Field", name: { kind: "Name", value: "qualname" } },
                                  { kind: "Field", name: { kind: "Name", value: "severity" } },
                                  { kind: "Field", name: { kind: "Name", value: "willRetry" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pos" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                                  { kind: "Field", name: { kind: "Name", value: "endLine" } },
                                  { kind: "Field", name: { kind: "Name", value: "path" } },
                                  { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                                  { kind: "Field", name: { kind: "Name", value: "startLine" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sparkline" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "running" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "destination" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "NoPublishedScriptbook" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomepageQuery, HomepageQueryVariables>;
export const DownloadDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "downloadName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "refresh" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "downloadName" },
                value: { kind: "Variable", name: { kind: "Name", value: "downloadName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "refresh" },
                value: { kind: "Variable", name: { kind: "Name", value: "refresh" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "created" } },
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "purpose" } },
                      { kind: "Field", name: { kind: "Name", value: "qualname" } },
                      { kind: "Field", name: { kind: "Name", value: "severity" } },
                      { kind: "Field", name: { kind: "Name", value: "willRetry" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                      { kind: "Field", name: { kind: "Name", value: "endLine" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                      { kind: "Field", name: { kind: "Name", value: "startLine" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "refreshedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sparkline" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "running" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sparklineFirstDate" } },
                { kind: "Field", name: { kind: "Name", value: "scriptbookId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keysUsedByDownload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "uploadsUsingDownload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadDetailsQuery, DownloadDetailsQueryVariables>;
export const UploadDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "uploadDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uploadName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "refresh" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadName" },
                value: { kind: "Variable", name: { kind: "Name", value: "uploadName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "refresh" },
                value: { kind: "Variable", name: { kind: "Name", value: "refresh" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "event" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "created" } },
                      { kind: "Field", name: { kind: "Name", value: "eventId" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      { kind: "Field", name: { kind: "Name", value: "purpose" } },
                      { kind: "Field", name: { kind: "Name", value: "qualname" } },
                      { kind: "Field", name: { kind: "Name", value: "severity" } },
                      { kind: "Field", name: { kind: "Name", value: "willRetry" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "destination" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "endColumn" } },
                      { kind: "Field", name: { kind: "Name", value: "endLine" } },
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      { kind: "Field", name: { kind: "Name", value: "startColumn" } },
                      { kind: "Field", name: { kind: "Name", value: "startLine" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "refreshedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sparkline" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "running" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sparklineFirstDate" } },
                { kind: "Field", name: { kind: "Name", value: "scriptbookId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keysUsedByUpload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadsUsedByUpload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadDetailsQuery, UploadDetailsQueryVariables>;
export const ImpactedAssetsCredentialDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "impactedAssetsCredential" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "credentialName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "impactedDownloads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "credentialName" },
                value: { kind: "Variable", name: { kind: "Name", value: "credentialName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "impactedUploads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "credentialName" },
                value: { kind: "Variable", name: { kind: "Name", value: "credentialName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImpactedAssetsCredentialQuery, ImpactedAssetsCredentialQueryVariables>;
export const GetIntegrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "get_integration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "integration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "integration_type" } },
                { kind: "Field", name: { kind: "Name", value: "public_authorization" } },
                { kind: "Field", name: { kind: "Name", value: "configuration" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "filters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "production" } },
                      { kind: "Field", name: { kind: "Name", value: "backfills" } },
                      { kind: "Field", name: { kind: "Name", value: "proofs" } },
                      { kind: "Field", name: { kind: "Name", value: "lateUploads" } },
                      { kind: "Field", name: { kind: "Name", value: "configuration" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "assistance" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIntegrationQuery, GetIntegrationQueryVariables>;
export const GetIntegrationChannelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "get_integration_channel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "channelId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "integration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "channel_by_id" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "channel_id" },
                      value: { kind: "Variable", name: { kind: "Name", value: "channelId" } },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIntegrationChannelQuery, GetIntegrationChannelQueryVariables>;
export const ListIntegrationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "list_integrations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "integrations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "integration_type" } },
                            { kind: "Field", name: { kind: "Name", value: "public_authorization" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListIntegrationsQuery, ListIntegrationsQueryVariables>;
export const StartOauthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "start_oauth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "entity" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "oauthType" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "start_oauth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "entity" },
                value: { kind: "Variable", name: { kind: "Name", value: "entity" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oauthType" },
                value: { kind: "Variable", name: { kind: "Name", value: "oauthType" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartOauthQuery, StartOauthQueryVariables>;
export const StartKeyOauthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "start_key_oauth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "entity" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "oauthType" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "start_oauth" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "entity" },
                value: { kind: "Variable", name: { kind: "Name", value: "entity" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "oauthType" },
                value: { kind: "Variable", name: { kind: "Name", value: "oauthType" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "validateCredentialUniqueName" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ValidateCredentialOk" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ValidationErrors" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "errors" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "typeId" } },
                            { kind: "Field", name: { kind: "Name", value: "properties" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartKeyOauthQuery, StartKeyOauthQueryVariables>;
export const KeyDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "keyDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "keyName" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "keyDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "keyName" },
                value: { kind: "Variable", name: { kind: "Name", value: "keyName" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "keyStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "uploadsUsingKey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadsUsingKey" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KeyDetailsQuery, KeyDetailsQueryVariables>;
export const UserPreferenceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userPreference" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userPreference" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserPreferenceQuery, UserPreferenceQueryVariables>;
export const SavePreferenceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "savePreference" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "value" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GenericScalar" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "savePreference" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "value" },
                value: { kind: "Variable", name: { kind: "Name", value: "value" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "ok" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SavePreferenceMutation, SavePreferenceMutationVariables>;
export const ChangelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "changelist" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "files" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "path" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangelistQuery, ChangelistQueryVariables>;
export const PublishedSourceBundlesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "published_source_bundles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "can_backfill" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "source_bundles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "bundle_name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tables" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "can_backfill" },
                                  value: { kind: "Variable", name: { kind: "Name", value: "can_backfill" } },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "credential" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishedSourceBundlesQuery, PublishedSourceBundlesQueryVariables>;
export const ExportDeclarationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "export_declarations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "export_declarations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "credential" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "destination" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportDeclarationsQuery, ExportDeclarationsQueryVariables>;
export const ExportDeclarationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "export_declaration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "export_declaration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subgraph" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "download_declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "bundle_name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exports" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "upload_declarations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportDeclarationQuery, ExportDeclarationQueryVariables>;
export const SuspendedAssetsQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "suspended_assets_query" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "credentials" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "credential_type" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "export_declarations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            { kind: "Field", name: { kind: "Name", value: "line" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "credential" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "source_bundles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "line" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exports" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "credential" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SuspendedAssetsQueryQuery, SuspendedAssetsQueryQueryVariables>;
export const DownloadRowsReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadRowsReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dimensions" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "RowsReportFiltersInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadRowsReport" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dimensions" },
                      value: { kind: "Variable", name: { kind: "Name", value: "dimensions" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                      { kind: "Field", name: { kind: "Name", value: "month" } },
                      { kind: "Field", name: { kind: "Name", value: "year" } },
                      { kind: "Field", name: { kind: "Name", value: "purpose" } },
                      { kind: "Field", name: { kind: "Name", value: "totalRowCount" } },
                      { kind: "Field", name: { kind: "Name", value: "totalByteCount" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "forecast" } },
                { kind: "Field", name: { kind: "Name", value: "contracted" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadRowsReportQuery, DownloadRowsReportQueryVariables>;
export const SchemasDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "schemas" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sbs_schemas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchemasQuery, SchemasQueryVariables>;
export const SchemaByNameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "schema_by_name" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sbs_schema" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "text" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchemaByNameQuery, SchemaByNameQueryVariables>;
export const SourceBundlesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "source_bundles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "importName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "project" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "source_bundles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "importName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: { kind: "Variable", name: { kind: "Name", value: "project" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "import_type" } },
                            { kind: "Field", name: { kind: "Name", value: "descriptor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "descriptor" } },
                                  { kind: "Field", name: { kind: "Name", value: "schema" } },
                                  { kind: "Field", name: { kind: "Name", value: "changelist_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                  { kind: "Field", name: { kind: "Name", value: "line" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exports" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "export_type" } },
                                        { kind: "Field", name: { kind: "Name", value: "descriptor" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "schema" } },
                                        { kind: "Field", name: { kind: "Name", value: "changelist_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "project" } },
                                        { kind: "Field", name: { kind: "Name", value: "line" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SourceBundlesQuery, SourceBundlesQueryVariables>;
export const SourceBundlesVolumeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "source_bundles_volume" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "importName" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "project" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "source_bundles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "importName" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: { kind: "Variable", name: { kind: "Name", value: "project" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "import_type" } },
                            { kind: "Field", name: { kind: "Name", value: "descriptor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tables" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "descriptor" } },
                                  { kind: "Field", name: { kind: "Name", value: "parameters" } },
                                  { kind: "Field", name: { kind: "Name", value: "changelist_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "project" } },
                                  { kind: "Field", name: { kind: "Name", value: "line" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "exports" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        { kind: "Field", name: { kind: "Name", value: "export_type" } },
                                        { kind: "Field", name: { kind: "Name", value: "descriptor" } },
                                        { kind: "Field", name: { kind: "Name", value: "changelist_id" } },
                                        { kind: "Field", name: { kind: "Name", value: "project" } },
                                        { kind: "Field", name: { kind: "Name", value: "line" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "volume" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "production_rows" } },
                                        { kind: "Field", name: { kind: "Name", value: "production_bytes" } },
                                        { kind: "Field", name: { kind: "Name", value: "refill_rows" } },
                                        { kind: "Field", name: { kind: "Name", value: "refill_bytes" } },
                                        { kind: "Field", name: { kind: "Name", value: "backfill_rows" } },
                                        { kind: "Field", name: { kind: "Name", value: "backfill_bytes" } },
                                        { kind: "Field", name: { kind: "Name", value: "proof_rows" } },
                                        { kind: "Field", name: { kind: "Name", value: "proof_bytes" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SourceBundlesVolumeQuery, SourceBundlesVolumeQueryVariables>;
export const ExportStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "export_status" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "group_by" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "project" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lookback_days" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "export_status" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "group_by" },
                value: { kind: "Variable", name: { kind: "Name", value: "group_by" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: { kind: "Variable", name: { kind: "Name", value: "project" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lookback_days" },
                value: { kind: "Variable", name: { kind: "Name", value: "lookback_days" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "credential" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "journal" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "date" } },
                                  { kind: "Field", name: { kind: "Name", value: "running" } },
                                  { kind: "Field", name: { kind: "Name", value: "completed" } },
                                  { kind: "Field", name: { kind: "Name", value: "failed" } },
                                  { kind: "Field", name: { kind: "Name", value: "total_rows" } },
                                  { kind: "Field", name: { kind: "Name", value: "min_rows" } },
                                  { kind: "Field", name: { kind: "Name", value: "max_rows" } },
                                  { kind: "Field", name: { kind: "Name", value: "total_bytes" } },
                                  { kind: "Field", name: { kind: "Name", value: "min_bytes" } },
                                  { kind: "Field", name: { kind: "Name", value: "max_bytes" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportStatusQuery, ExportStatusQueryVariables>;
export const ImportStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "import_status" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "group_by" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "project" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lookback_days" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "import_status" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "group_by" },
                value: { kind: "Variable", name: { kind: "Name", value: "group_by" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: { kind: "Variable", name: { kind: "Name", value: "project" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lookback_days" },
                value: { kind: "Variable", name: { kind: "Name", value: "lookback_days" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "credential" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "journal" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "date" } },
                                  { kind: "Field", name: { kind: "Name", value: "running" } },
                                  { kind: "Field", name: { kind: "Name", value: "completed" } },
                                  { kind: "Field", name: { kind: "Name", value: "failed" } },
                                  { kind: "Field", name: { kind: "Name", value: "total_rows" } },
                                  { kind: "Field", name: { kind: "Name", value: "min_rows" } },
                                  { kind: "Field", name: { kind: "Name", value: "max_rows" } },
                                  { kind: "Field", name: { kind: "Name", value: "total_bytes" } },
                                  { kind: "Field", name: { kind: "Name", value: "min_bytes" } },
                                  { kind: "Field", name: { kind: "Name", value: "max_bytes" } },
                                  { kind: "Field", name: { kind: "Name", value: "dirty_rows" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImportStatusQuery, ImportStatusQueryVariables>;
export const TestFlowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "test_flows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flows" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "purpose" },
                value: { kind: "StringValue", value: "proof", block: false },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "archived" },
                value: { kind: "BooleanValue", value: false },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "FlowsFragment" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FlowsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Flow" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "changelist" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "launched_by" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "created" } },
          { kind: "Field", name: { kind: "Name", value: "failed" } },
          { kind: "Field", name: { kind: "Name", value: "phase" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "report_datetime" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "short" } },
                { kind: "Field", name: { kind: "Name", value: "long" } },
                { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                { kind: "Field", name: { kind: "Name", value: "iso" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "inputs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "source_table" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bundle" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "report_handle" } },
                            { kind: "Field", name: { kind: "Name", value: "recent_failed_probe" } },
                            { kind: "Field", name: { kind: "Name", value: "recent_successful_probe" } },
                            { kind: "Field", name: { kind: "Name", value: "next_probe" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "download" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "report_datetime" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "short" } },
                            { kind: "Field", name: { kind: "Name", value: "long" } },
                            { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                            { kind: "Field", name: { kind: "Name", value: "iso" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "created" } },
                      { kind: "Field", name: { kind: "Name", value: "started" } },
                      { kind: "Field", name: { kind: "Name", value: "finished" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "handle" } },
                      { kind: "Field", name: { kind: "Name", value: "progress" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "download_part" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "row_count" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
                      { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
                      { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "download" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "processing" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "outputs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "project" } },
                { kind: "Field", name: { kind: "Name", value: "handle" } },
                { kind: "Field", name: { kind: "Name", value: "row_count" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report_datetime" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "short" } },
                      { kind: "Field", name: { kind: "Name", value: "long" } },
                      { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                      { kind: "Field", name: { kind: "Name", value: "iso" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "declaration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "events" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "severity" } },
                { kind: "Field", name: { kind: "Name", value: "project_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "download" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flow" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "upload" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "will_retry" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "commented_on" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "commented_by" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TestFlowsQuery, TestFlowsQueryVariables>;
export const UploadDownloadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "upload_downloads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "upload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inputs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "InputsFragment" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InputsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DownloadPart" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
          { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
          { kind: "Field", name: { kind: "Name", value: "new_dirty_row_count" } },
          { kind: "Field", name: { kind: "Name", value: "new_dirty_row_status" } },
          { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
          { kind: "Field", name: { kind: "Name", value: "row_count" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "source_table" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "project" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "download" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "handle" } },
                { kind: "Field", name: { kind: "Name", value: "purpose" } },
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report_datetime" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "short" } },
                      { kind: "Field", name: { kind: "Name", value: "long" } },
                      { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                      { kind: "Field", name: { kind: "Name", value: "iso" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "source_tables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadDownloadsQuery, UploadDownloadsQueryVariables>;
export const AllUploadDownloadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "all_upload_downloads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "row_count" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "started" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "report_datetime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "short" } },
                                  { kind: "Field", name: { kind: "Name", value: "long" } },
                                  { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                  { kind: "Field", name: { kind: "Name", value: "iso" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "destination" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "inputs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "InputsFragment" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InputsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DownloadPart" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "dirty_row_count" } },
          { kind: "Field", name: { kind: "Name", value: "dirty_row_status" } },
          { kind: "Field", name: { kind: "Name", value: "new_dirty_row_count" } },
          { kind: "Field", name: { kind: "Name", value: "new_dirty_row_status" } },
          { kind: "Field", name: { kind: "Name", value: "legacy_flow_source_id" } },
          { kind: "Field", name: { kind: "Name", value: "row_count" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "source_table" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "project" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "download" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created" } },
                { kind: "Field", name: { kind: "Name", value: "finished" } },
                { kind: "Field", name: { kind: "Name", value: "handle" } },
                { kind: "Field", name: { kind: "Name", value: "purpose" } },
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "report_datetime" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "short" } },
                      { kind: "Field", name: { kind: "Name", value: "long" } },
                      { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                      { kind: "Field", name: { kind: "Name", value: "iso" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "source_tables" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "project" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "started" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllUploadDownloadsQuery, AllUploadDownloadsQueryVariables>;
export const UploadForDownloadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "upload_for_downloads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "download_part_id" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "downloadPartIds" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "download_part_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "download_part_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "downloadPartIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "downloadPartIds" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "row_count" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "purpose" } },
                            { kind: "Field", name: { kind: "Name", value: "started" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "report_datetime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "short" } },
                                  { kind: "Field", name: { kind: "Name", value: "long" } },
                                  { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                  { kind: "Field", name: { kind: "Name", value: "iso" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "destination" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadForDownloadsQuery, UploadForDownloadsQueryVariables>;
export const UploadsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "uploads" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "names" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "project" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projects" } },
          type: { kind: "ListType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "purpose" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uploaded_after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uploaded_before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "destination" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DataGridSortableColumns" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortDirection" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uploads" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: { kind: "Variable", name: { kind: "Name", value: "name" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "names" },
                value: { kind: "Variable", name: { kind: "Name", value: "names" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "project" },
                value: { kind: "Variable", name: { kind: "Name", value: "project" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projects" },
                value: { kind: "Variable", name: { kind: "Name", value: "projects" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "purpose" },
                value: { kind: "Variable", name: { kind: "Name", value: "purpose" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "report_datetime_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "report_datetime_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "search" },
                value: { kind: "Variable", name: { kind: "Name", value: "search" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploaded_after" },
                value: { kind: "Variable", name: { kind: "Name", value: "uploaded_after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploaded_before" },
                value: { kind: "Variable", name: { kind: "Name", value: "uploaded_before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "destination" },
                value: { kind: "Variable", name: { kind: "Name", value: "destination" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortBy" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortDirection" },
                value: { kind: "Variable", name: { kind: "Name", value: "sortDirection" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "project" } },
                            { kind: "Field", name: { kind: "Name", value: "purpose" } },
                            { kind: "Field", name: { kind: "Name", value: "handle" } },
                            { kind: "Field", name: { kind: "Name", value: "row_count" } },
                            { kind: "Field", name: { kind: "Name", value: "created" } },
                            { kind: "Field", name: { kind: "Name", value: "started" } },
                            { kind: "Field", name: { kind: "Name", value: "finished" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "report_datetime" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "short" } },
                                  { kind: "Field", name: { kind: "Name", value: "long" } },
                                  { kind: "Field", name: { kind: "Name", value: "long_utc" } },
                                  { kind: "Field", name: { kind: "Name", value: "iso" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "destination" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadsQuery, UploadsQueryVariables>;
export const UsersListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "usersList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "last" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "before" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "last" },
                value: { kind: "Variable", name: { kind: "Name", value: "last" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "before" },
                value: { kind: "Variable", name: { kind: "Name", value: "before" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "globalRoles" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersListQuery, UsersListQueryVariables>;
export const UserDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "userDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "globalRoles" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "urlName" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "roles" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "connectionType" } },
                      { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
                      { kind: "Field", name: { kind: "Name", value: "blocked" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserDetailsQuery, UserDetailsQueryVariables>;
export const AccountsForLoggedUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "accountsForLoggedUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "urlName" } },
                      { kind: "Field", name: { kind: "Name", value: "show_download_summary" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountsForLoggedUserQuery, AccountsForLoggedUserQueryVariables>;
